"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AbstractChargeLineItem", {
  enumerable: true,
  get: function get() {
    return _AbstractChargeLineItem["default"];
  }
});
Object.defineProperty(exports, "Accessorial", {
  enumerable: true,
  get: function get() {
    return _Accessorial["default"];
  }
});
Object.defineProperty(exports, "AccessorialChargeTable", {
  enumerable: true,
  get: function get() {
    return _AccessorialChargeTable["default"];
  }
});
Object.defineProperty(exports, "AccessorialChargeTableCalculationRow", {
  enumerable: true,
  get: function get() {
    return _AccessorialChargeTableCalculationRow["default"];
  }
});
Object.defineProperty(exports, "Address", {
  enumerable: true,
  get: function get() {
    return _Address["default"];
  }
});
Object.defineProperty(exports, "AddressBookEntry", {
  enumerable: true,
  get: function get() {
    return _AddressBookEntry["default"];
  }
});
Object.defineProperty(exports, "AddressTemplate", {
  enumerable: true,
  get: function get() {
    return _AddressTemplate["default"];
  }
});
Object.defineProperty(exports, "AlertDashboardSlimCarrierRelationship", {
  enumerable: true,
  get: function get() {
    return _AlertDashboardSlimCarrierRelationship["default"];
  }
});
Object.defineProperty(exports, "AlertDashboardSlimCarrierRelationshipCarrier", {
  enumerable: true,
  get: function get() {
    return _AlertDashboardSlimCarrierRelationshipCarrier["default"];
  }
});
Object.defineProperty(exports, "AlertDashboardSlimShipment", {
  enumerable: true,
  get: function get() {
    return _AlertDashboardSlimShipment["default"];
  }
});
Object.defineProperty(exports, "AlertEvent", {
  enumerable: true,
  get: function get() {
    return _AlertEvent["default"];
  }
});
Object.defineProperty(exports, "AlertsDashBoardConfiguration", {
  enumerable: true,
  get: function get() {
    return _AlertsDashBoardConfiguration["default"];
  }
});
Object.defineProperty(exports, "AlertsDashBoardConfigurationOptions", {
  enumerable: true,
  get: function get() {
    return _AlertsDashBoardConfigurationOptions["default"];
  }
});
Object.defineProperty(exports, "AlertsDashBoardConfigurationOptionsThresholdDefinition", {
  enumerable: true,
  get: function get() {
    return _AlertsDashBoardConfigurationOptionsThresholdDefinition["default"];
  }
});
Object.defineProperty(exports, "AndroidMinVersion", {
  enumerable: true,
  get: function get() {
    return _AndroidMinVersion["default"];
  }
});
Object.defineProperty(exports, "ApiClient", {
  enumerable: true,
  get: function get() {
    return _ApiClient["default"];
  }
});
Object.defineProperty(exports, "ApiKey", {
  enumerable: true,
  get: function get() {
    return _ApiKey["default"];
  }
});
Object.defineProperty(exports, "ApiKey1", {
  enumerable: true,
  get: function get() {
    return _ApiKey2["default"];
  }
});
Object.defineProperty(exports, "AppointmentType", {
  enumerable: true,
  get: function get() {
    return _AppointmentType["default"];
  }
});
Object.defineProperty(exports, "AssetsAccessBody", {
  enumerable: true,
  get: function get() {
    return _AssetsAccessBody["default"];
  }
});
Object.defineProperty(exports, "AuctionStats", {
  enumerable: true,
  get: function get() {
    return _AuctionStats["default"];
  }
});
Object.defineProperty(exports, "AutoBookRequest", {
  enumerable: true,
  get: function get() {
    return _AutoBookRequest["default"];
  }
});
Object.defineProperty(exports, "AutomatedVendorProfile", {
  enumerable: true,
  get: function get() {
    return _AutomatedVendorProfile["default"];
  }
});
Object.defineProperty(exports, "AutomationEvent", {
  enumerable: true,
  get: function get() {
    return _AutomationEvent["default"];
  }
});
Object.defineProperty(exports, "AutomationEventSubType", {
  enumerable: true,
  get: function get() {
    return _AutomationEventSubType["default"];
  }
});
Object.defineProperty(exports, "AwardDeclineQuoteRequest", {
  enumerable: true,
  get: function get() {
    return _AwardDeclineQuoteRequest["default"];
  }
});
Object.defineProperty(exports, "AwardQuoteRequest", {
  enumerable: true,
  get: function get() {
    return _AwardQuoteRequest["default"];
  }
});
Object.defineProperty(exports, "BaseCarrierRelationship", {
  enumerable: true,
  get: function get() {
    return _BaseCarrierRelationship["default"];
  }
});
Object.defineProperty(exports, "BaseCarrierRelationshipCarrierDirectIntegrationProfile", {
  enumerable: true,
  get: function get() {
    return _BaseCarrierRelationshipCarrierDirectIntegrationProfile["default"];
  }
});
Object.defineProperty(exports, "BasePointOfContact", {
  enumerable: true,
  get: function get() {
    return _BasePointOfContact["default"];
  }
});
Object.defineProperty(exports, "BaseProductDescription", {
  enumerable: true,
  get: function get() {
    return _BaseProductDescription["default"];
  }
});
Object.defineProperty(exports, "BaseShipment", {
  enumerable: true,
  get: function get() {
    return _BaseShipment["default"];
  }
});
Object.defineProperty(exports, "Bill", {
  enumerable: true,
  get: function get() {
    return _Bill["default"];
  }
});
Object.defineProperty(exports, "BillDocuments", {
  enumerable: true,
  get: function get() {
    return _BillDocuments["default"];
  }
});
Object.defineProperty(exports, "BillLineItem", {
  enumerable: true,
  get: function get() {
    return _BillLineItem["default"];
  }
});
Object.defineProperty(exports, "BillRemitTo", {
  enumerable: true,
  get: function get() {
    return _BillRemitTo["default"];
  }
});
Object.defineProperty(exports, "BillRemitToRemitToInfo", {
  enumerable: true,
  get: function get() {
    return _BillRemitToRemitToInfo["default"];
  }
});
Object.defineProperty(exports, "BillShipment", {
  enumerable: true,
  get: function get() {
    return _BillShipment["default"];
  }
});
Object.defineProperty(exports, "BillToOverride", {
  enumerable: true,
  get: function get() {
    return _BillToOverride["default"];
  }
});
Object.defineProperty(exports, "BillingIntegrationsQuickbooksExpensesCategoriesMappingExpenseAccount", {
  enumerable: true,
  get: function get() {
    return _BillingIntegrationsQuickbooksExpensesCategoriesMappingExpenseAccount["default"];
  }
});
Object.defineProperty(exports, "Brokerage", {
  enumerable: true,
  get: function get() {
    return _Brokerage["default"];
  }
});
Object.defineProperty(exports, "BulkCreateSpotNegotiationRequest", {
  enumerable: true,
  get: function get() {
    return _BulkCreateSpotNegotiationRequest["default"];
  }
});
Object.defineProperty(exports, "BulkPrintLabelsRequest", {
  enumerable: true,
  get: function get() {
    return _BulkPrintLabelsRequest["default"];
  }
});
Object.defineProperty(exports, "BulkPrintLabelsResponse", {
  enumerable: true,
  get: function get() {
    return _BulkPrintLabelsResponse["default"];
  }
});
Object.defineProperty(exports, "BulkPrintLabelsResponseLabels", {
  enumerable: true,
  get: function get() {
    return _BulkPrintLabelsResponseLabels["default"];
  }
});
Object.defineProperty(exports, "BuyItNow", {
  enumerable: true,
  get: function get() {
    return _BuyItNow["default"];
  }
});
Object.defineProperty(exports, "CEVARate", {
  enumerable: true,
  get: function get() {
    return _CEVARate["default"];
  }
});
Object.defineProperty(exports, "CEVARates", {
  enumerable: true,
  get: function get() {
    return _CEVARates["default"];
  }
});
Object.defineProperty(exports, "CEVAStateZoneRates", {
  enumerable: true,
  get: function get() {
    return _CEVAStateZoneRates["default"];
  }
});
Object.defineProperty(exports, "CEVAStateZoneRates1", {
  enumerable: true,
  get: function get() {
    return _CEVAStateZoneRates2["default"];
  }
});
Object.defineProperty(exports, "CEVAZoneToZoneMapping", {
  enumerable: true,
  get: function get() {
    return _CEVAZoneToZoneMapping["default"];
  }
});
Object.defineProperty(exports, "CEVAZoneToZoneMappings", {
  enumerable: true,
  get: function get() {
    return _CEVAZoneToZoneMappings["default"];
  }
});
Object.defineProperty(exports, "CHRobinsonAccountRequest", {
  enumerable: true,
  get: function get() {
    return _CHRobinsonAccountRequest["default"];
  }
});
Object.defineProperty(exports, "CHRobinsonAccountResponse", {
  enumerable: true,
  get: function get() {
    return _CHRobinsonAccountResponse["default"];
  }
});
Object.defineProperty(exports, "CanLinkDriverResponse", {
  enumerable: true,
  get: function get() {
    return _CanLinkDriverResponse["default"];
  }
});
Object.defineProperty(exports, "CancellationRequest", {
  enumerable: true,
  get: function get() {
    return _CancellationRequest["default"];
  }
});
Object.defineProperty(exports, "Carrier", {
  enumerable: true,
  get: function get() {
    return _Carrier["default"];
  }
});
Object.defineProperty(exports, "CarrierAssignment", {
  enumerable: true,
  get: function get() {
    return _CarrierAssignment["default"];
  }
});
Object.defineProperty(exports, "CarrierBid", {
  enumerable: true,
  get: function get() {
    return _CarrierBid["default"];
  }
});
Object.defineProperty(exports, "CarrierBiddingSummaryShipment", {
  enumerable: true,
  get: function get() {
    return _CarrierBiddingSummaryShipment["default"];
  }
});
Object.defineProperty(exports, "CarrierCapacityAvailabilityResponse", {
  enumerable: true,
  get: function get() {
    return _CarrierCapacityAvailabilityResponse["default"];
  }
});
Object.defineProperty(exports, "CarrierCapacityRecord", {
  enumerable: true,
  get: function get() {
    return _CarrierCapacityRecord["default"];
  }
});
Object.defineProperty(exports, "CarrierConfig", {
  enumerable: true,
  get: function get() {
    return _CarrierConfig["default"];
  }
});
Object.defineProperty(exports, "CarrierCustomData", {
  enumerable: true,
  get: function get() {
    return _CarrierCustomData["default"];
  }
});
Object.defineProperty(exports, "CarrierDriver", {
  enumerable: true,
  get: function get() {
    return _CarrierDriver["default"];
  }
});
Object.defineProperty(exports, "CarrierELDProvider", {
  enumerable: true,
  get: function get() {
    return _CarrierELDProvider["default"];
  }
});
Object.defineProperty(exports, "CarrierInsurance", {
  enumerable: true,
  get: function get() {
    return _CarrierInsurance["default"];
  }
});
Object.defineProperty(exports, "CarrierPocTag", {
  enumerable: true,
  get: function get() {
    return _CarrierPocTag["default"];
  }
});
Object.defineProperty(exports, "CarrierPointOfContact", {
  enumerable: true,
  get: function get() {
    return _CarrierPointOfContact["default"];
  }
});
Object.defineProperty(exports, "CarrierPointOfContactAllOf", {
  enumerable: true,
  get: function get() {
    return _CarrierPointOfContactAllOf["default"];
  }
});
Object.defineProperty(exports, "CarrierReferenceCode", {
  enumerable: true,
  get: function get() {
    return _CarrierReferenceCode["default"];
  }
});
Object.defineProperty(exports, "CarrierRelationship", {
  enumerable: true,
  get: function get() {
    return _CarrierRelationship["default"];
  }
});
Object.defineProperty(exports, "CarrierRelationshipAllOf", {
  enumerable: true,
  get: function get() {
    return _CarrierRelationshipAllOf["default"];
  }
});
Object.defineProperty(exports, "CarrierSpecificShipperRelationship", {
  enumerable: true,
  get: function get() {
    return _CarrierSpecificShipperRelationship["default"];
  }
});
Object.defineProperty(exports, "CarrierStatus", {
  enumerable: true,
  get: function get() {
    return _CarrierStatus["default"];
  }
});
Object.defineProperty(exports, "CarrierStatusCarrierAssignment", {
  enumerable: true,
  get: function get() {
    return _CarrierStatusCarrierAssignment["default"];
  }
});
Object.defineProperty(exports, "CarrierStatusCarrierAssignmentAllOf", {
  enumerable: true,
  get: function get() {
    return _CarrierStatusCarrierAssignmentAllOf["default"];
  }
});
Object.defineProperty(exports, "CarrierTag", {
  enumerable: true,
  get: function get() {
    return _CarrierTag["default"];
  }
});
Object.defineProperty(exports, "CaseNote", {
  enumerable: true,
  get: function get() {
    return _CaseNote["default"];
  }
});
Object.defineProperty(exports, "CellTrackingInitRequest", {
  enumerable: true,
  get: function get() {
    return _CellTrackingInitRequest["default"];
  }
});
Object.defineProperty(exports, "ChangePassword", {
  enumerable: true,
  get: function get() {
    return _ChangePassword["default"];
  }
});
Object.defineProperty(exports, "ChargeCategory", {
  enumerable: true,
  get: function get() {
    return _ChargeCategory["default"];
  }
});
Object.defineProperty(exports, "ChargeCode", {
  enumerable: true,
  get: function get() {
    return _ChargeCode["default"];
  }
});
Object.defineProperty(exports, "ChargeLineItemCategory", {
  enumerable: true,
  get: function get() {
    return _ChargeLineItemCategory["default"];
  }
});
Object.defineProperty(exports, "Company", {
  enumerable: true,
  get: function get() {
    return _Company["default"];
  }
});
Object.defineProperty(exports, "CompanyAllOf", {
  enumerable: true,
  get: function get() {
    return _CompanyAllOf["default"];
  }
});
Object.defineProperty(exports, "CompanyCustomData", {
  enumerable: true,
  get: function get() {
    return _CompanyCustomData["default"];
  }
});
Object.defineProperty(exports, "CompanyLogo", {
  enumerable: true,
  get: function get() {
    return _CompanyLogo["default"];
  }
});
Object.defineProperty(exports, "CompanyPreferences", {
  enumerable: true,
  get: function get() {
    return _CompanyPreferences["default"];
  }
});
Object.defineProperty(exports, "CompanyWithOptionalUsers", {
  enumerable: true,
  get: function get() {
    return _CompanyWithOptionalUsers["default"];
  }
});
Object.defineProperty(exports, "CompanyWithOptionalUsersAllOf", {
  enumerable: true,
  get: function get() {
    return _CompanyWithOptionalUsersAllOf["default"];
  }
});
Object.defineProperty(exports, "CompletePushResponse", {
  enumerable: true,
  get: function get() {
    return _CompletePushResponse["default"];
  }
});
Object.defineProperty(exports, "ConfiguredFMS", {
  enumerable: true,
  get: function get() {
    return _ConfiguredFMS["default"];
  }
});
Object.defineProperty(exports, "ConfiguredFMSConfiguredIntegrations", {
  enumerable: true,
  get: function get() {
    return _ConfiguredFMSConfiguredIntegrations["default"];
  }
});
Object.defineProperty(exports, "Contract", {
  enumerable: true,
  get: function get() {
    return _Contract["default"];
  }
});
Object.defineProperty(exports, "ContractRateTypes", {
  enumerable: true,
  get: function get() {
    return _ContractRateTypes["default"];
  }
});
Object.defineProperty(exports, "ContractStatuses", {
  enumerable: true,
  get: function get() {
    return _ContractStatuses["default"];
  }
});
Object.defineProperty(exports, "CreateApiKey", {
  enumerable: true,
  get: function get() {
    return _CreateApiKey["default"];
  }
});
Object.defineProperty(exports, "CreateCompanyRequestBody", {
  enumerable: true,
  get: function get() {
    return _CreateCompanyRequestBody["default"];
  }
});
Object.defineProperty(exports, "CreateEquipmentConfig", {
  enumerable: true,
  get: function get() {
    return _CreateEquipmentConfig["default"];
  }
});
Object.defineProperty(exports, "CreateQuote", {
  enumerable: true,
  get: function get() {
    return _CreateQuote["default"];
  }
});
Object.defineProperty(exports, "CreateQuoteAllOf", {
  enumerable: true,
  get: function get() {
    return _CreateQuoteAllOf["default"];
  }
});
Object.defineProperty(exports, "CreateShipmentRepRequest", {
  enumerable: true,
  get: function get() {
    return _CreateShipmentRepRequest["default"];
  }
});
Object.defineProperty(exports, "CreateShipmentTimelineEvent", {
  enumerable: true,
  get: function get() {
    return _CreateShipmentTimelineEvent["default"];
  }
});
Object.defineProperty(exports, "CreateShipmentTimelineEventAllOf", {
  enumerable: true,
  get: function get() {
    return _CreateShipmentTimelineEventAllOf["default"];
  }
});
Object.defineProperty(exports, "CreateShipperRelationship", {
  enumerable: true,
  get: function get() {
    return _CreateShipperRelationship["default"];
  }
});
Object.defineProperty(exports, "CreateShipperRelationshipAllOf", {
  enumerable: true,
  get: function get() {
    return _CreateShipperRelationshipAllOf["default"];
  }
});
Object.defineProperty(exports, "CreateSpotNegotiationQuote", {
  enumerable: true,
  get: function get() {
    return _CreateSpotNegotiationQuote["default"];
  }
});
Object.defineProperty(exports, "CreateSpotNegotiationQuoteAllOf", {
  enumerable: true,
  get: function get() {
    return _CreateSpotNegotiationQuoteAllOf["default"];
  }
});
Object.defineProperty(exports, "CreateTimelineEventTemplate", {
  enumerable: true,
  get: function get() {
    return _CreateTimelineEventTemplate["default"];
  }
});
Object.defineProperty(exports, "CurrencyCode", {
  enumerable: true,
  get: function get() {
    return _CurrencyCode["default"];
  }
});
Object.defineProperty(exports, "CurrentBillToInformation", {
  enumerable: true,
  get: function get() {
    return _CurrentBillToInformation["default"];
  }
});
Object.defineProperty(exports, "CurrentShipmentAddress", {
  enumerable: true,
  get: function get() {
    return _CurrentShipmentAddress["default"];
  }
});
Object.defineProperty(exports, "CurrentShipmentAddressAllOf", {
  enumerable: true,
  get: function get() {
    return _CurrentShipmentAddressAllOf["default"];
  }
});
Object.defineProperty(exports, "CustomField", {
  enumerable: true,
  get: function get() {
    return _CustomField["default"];
  }
});
Object.defineProperty(exports, "CustomFieldAllowedValue", {
  enumerable: true,
  get: function get() {
    return _CustomFieldAllowedValue["default"];
  }
});
Object.defineProperty(exports, "CustomerCustomData", {
  enumerable: true,
  get: function get() {
    return _CustomerCustomData["default"];
  }
});
Object.defineProperty(exports, "CustomerNegotiationPreview", {
  enumerable: true,
  get: function get() {
    return _CustomerNegotiationPreview["default"];
  }
});
Object.defineProperty(exports, "Dashboard", {
  enumerable: true,
  get: function get() {
    return _Dashboard["default"];
  }
});
Object.defineProperty(exports, "DataDocksAppointment", {
  enumerable: true,
  get: function get() {
    return _DataDocksAppointment["default"];
  }
});
Object.defineProperty(exports, "DataDocksBookingInformation", {
  enumerable: true,
  get: function get() {
    return _DataDocksBookingInformation["default"];
  }
});
Object.defineProperty(exports, "DataDocksStopAppointment", {
  enumerable: true,
  get: function get() {
    return _DataDocksStopAppointment["default"];
  }
});
Object.defineProperty(exports, "DataImport", {
  enumerable: true,
  get: function get() {
    return _DataImport["default"];
  }
});
Object.defineProperty(exports, "DataImportError", {
  enumerable: true,
  get: function get() {
    return _DataImportError["default"];
  }
});
Object.defineProperty(exports, "DefaultApi", {
  enumerable: true,
  get: function get() {
    return _DefaultApi["default"];
  }
});
Object.defineProperty(exports, "Device", {
  enumerable: true,
  get: function get() {
    return _Device["default"];
  }
});
Object.defineProperty(exports, "DistanceRequest", {
  enumerable: true,
  get: function get() {
    return _DistanceRequest["default"];
  }
});
Object.defineProperty(exports, "DistanceResponse", {
  enumerable: true,
  get: function get() {
    return _DistanceResponse["default"];
  }
});
Object.defineProperty(exports, "DocumentAuditlog", {
  enumerable: true,
  get: function get() {
    return _DocumentAuditlog["default"];
  }
});
Object.defineProperty(exports, "DocumentMetadata", {
  enumerable: true,
  get: function get() {
    return _DocumentMetadata["default"];
  }
});
Object.defineProperty(exports, "DocumentType", {
  enumerable: true,
  get: function get() {
    return _DocumentType["default"];
  }
});
Object.defineProperty(exports, "Driver", {
  enumerable: true,
  get: function get() {
    return _Driver["default"];
  }
});
Object.defineProperty(exports, "DriverHOS", {
  enumerable: true,
  get: function get() {
    return _DriverHOS["default"];
  }
});
Object.defineProperty(exports, "DriverLog", {
  enumerable: true,
  get: function get() {
    return _DriverLog["default"];
  }
});
Object.defineProperty(exports, "DriverLogin", {
  enumerable: true,
  get: function get() {
    return _DriverLogin["default"];
  }
});
Object.defineProperty(exports, "DriverPinRequest", {
  enumerable: true,
  get: function get() {
    return _DriverPinRequest["default"];
  }
});
Object.defineProperty(exports, "DriverPushNotificationTypesEnum", {
  enumerable: true,
  get: function get() {
    return _DriverPushNotificationTypesEnum["default"];
  }
});
Object.defineProperty(exports, "DriverTokenResponse", {
  enumerable: true,
  get: function get() {
    return _DriverTokenResponse["default"];
  }
});
Object.defineProperty(exports, "DriverTokenResponse1", {
  enumerable: true,
  get: function get() {
    return _DriverTokenResponse2["default"];
  }
});
Object.defineProperty(exports, "EIAFuelRate", {
  enumerable: true,
  get: function get() {
    return _EIAFuelRate["default"];
  }
});
Object.defineProperty(exports, "ELDAddress", {
  enumerable: true,
  get: function get() {
    return _ELDAddress["default"];
  }
});
Object.defineProperty(exports, "ELDCredentials", {
  enumerable: true,
  get: function get() {
    return _ELDCredentials["default"];
  }
});
Object.defineProperty(exports, "ELDDeviceLocation", {
  enumerable: true,
  get: function get() {
    return _ELDDeviceLocation["default"];
  }
});
Object.defineProperty(exports, "ELDDriverStatus", {
  enumerable: true,
  get: function get() {
    return _ELDDriverStatus["default"];
  }
});
Object.defineProperty(exports, "ELDDriversCreated", {
  enumerable: true,
  get: function get() {
    return _ELDDriversCreated["default"];
  }
});
Object.defineProperty(exports, "ELDDriversCreatedSkippedDrivers", {
  enumerable: true,
  get: function get() {
    return _ELDDriversCreatedSkippedDrivers["default"];
  }
});
Object.defineProperty(exports, "ELDLocation", {
  enumerable: true,
  get: function get() {
    return _ELDLocation["default"];
  }
});
Object.defineProperty(exports, "ELDLocationUpdateRequest", {
  enumerable: true,
  get: function get() {
    return _ELDLocationUpdateRequest["default"];
  }
});
Object.defineProperty(exports, "ELDProvider", {
  enumerable: true,
  get: function get() {
    return _ELDProvider["default"];
  }
});
Object.defineProperty(exports, "ETAWindow", {
  enumerable: true,
  get: function get() {
    return _ETAWindow["default"];
  }
});
Object.defineProperty(exports, "EmailNotificationRequest", {
  enumerable: true,
  get: function get() {
    return _EmailNotificationRequest["default"];
  }
});
Object.defineProperty(exports, "EmbedUrlResponse", {
  enumerable: true,
  get: function get() {
    return _EmbedUrlResponse["default"];
  }
});
Object.defineProperty(exports, "EquipmentConfig", {
  enumerable: true,
  get: function get() {
    return _EquipmentConfig["default"];
  }
});
Object.defineProperty(exports, "EquipmentEnum", {
  enumerable: true,
  get: function get() {
    return _EquipmentEnum["default"];
  }
});
Object.defineProperty(exports, "EquipmentType", {
  enumerable: true,
  get: function get() {
    return _EquipmentType["default"];
  }
});
Object.defineProperty(exports, "EquipmentTypes", {
  enumerable: true,
  get: function get() {
    return _EquipmentTypes["default"];
  }
});
Object.defineProperty(exports, "ExtendedELDProvider", {
  enumerable: true,
  get: function get() {
    return _ExtendedELDProvider["default"];
  }
});
Object.defineProperty(exports, "FMCSACarrierPolicy", {
  enumerable: true,
  get: function get() {
    return _FMCSACarrierPolicy["default"];
  }
});
Object.defineProperty(exports, "FeatureFlags", {
  enumerable: true,
  get: function get() {
    return _FeatureFlags["default"];
  }
});
Object.defineProperty(exports, "FedexAccount", {
  enumerable: true,
  get: function get() {
    return _FedexAccount["default"];
  }
});
Object.defineProperty(exports, "FedexAccountContact", {
  enumerable: true,
  get: function get() {
    return _FedexAccountContact["default"];
  }
});
Object.defineProperty(exports, "FedexAccountResponse", {
  enumerable: true,
  get: function get() {
    return _FedexAccountResponse["default"];
  }
});
Object.defineProperty(exports, "FedexAccountResponseIsConnected", {
  enumerable: true,
  get: function get() {
    return _FedexAccountResponseIsConnected["default"];
  }
});
Object.defineProperty(exports, "FedexDirectQuote", {
  enumerable: true,
  get: function get() {
    return _FedexDirectQuote["default"];
  }
});
Object.defineProperty(exports, "FedexFreightAccount", {
  enumerable: true,
  get: function get() {
    return _FedexFreightAccount["default"];
  }
});
Object.defineProperty(exports, "FedexFreightAccountAllOf", {
  enumerable: true,
  get: function get() {
    return _FedexFreightAccountAllOf["default"];
  }
});
Object.defineProperty(exports, "FedexPackaging", {
  enumerable: true,
  get: function get() {
    return _FedexPackaging["default"];
  }
});
Object.defineProperty(exports, "FedexShipmentOptions", {
  enumerable: true,
  get: function get() {
    return _FedexShipmentOptions["default"];
  }
});
Object.defineProperty(exports, "FedexShipmentOptionsAllOf", {
  enumerable: true,
  get: function get() {
    return _FedexShipmentOptionsAllOf["default"];
  }
});
Object.defineProperty(exports, "FleetLocationResponse", {
  enumerable: true,
  get: function get() {
    return _FleetLocationResponse["default"];
  }
});
Object.defineProperty(exports, "FleetupCredentials", {
  enumerable: true,
  get: function get() {
    return _FleetupCredentials["default"];
  }
});
Object.defineProperty(exports, "FmcsaCarrier", {
  enumerable: true,
  get: function get() {
    return _FmcsaCarrier["default"];
  }
});
Object.defineProperty(exports, "FmcsaCensusData", {
  enumerable: true,
  get: function get() {
    return _FmcsaCensusData["default"];
  }
});
Object.defineProperty(exports, "FormattedAddress", {
  enumerable: true,
  get: function get() {
    return _FormattedAddress["default"];
  }
});
Object.defineProperty(exports, "FreightAuthorityVendorRelationshipIDList", {
  enumerable: true,
  get: function get() {
    return _FreightAuthorityVendorRelationshipIDList["default"];
  }
});
Object.defineProperty(exports, "FtlInstantRateDispatchRequest", {
  enumerable: true,
  get: function get() {
    return _FtlInstantRateDispatchRequest["default"];
  }
});
Object.defineProperty(exports, "FtlInstantRateDispatchResponse", {
  enumerable: true,
  get: function get() {
    return _FtlInstantRateDispatchResponse["default"];
  }
});
Object.defineProperty(exports, "FuelSurchargeTable", {
  enumerable: true,
  get: function get() {
    return _FuelSurchargeTable["default"];
  }
});
Object.defineProperty(exports, "FuelSurchargeTableCalculationRow", {
  enumerable: true,
  get: function get() {
    return _FuelSurchargeTableCalculationRow["default"];
  }
});
Object.defineProperty(exports, "FullNameDriver", {
  enumerable: true,
  get: function get() {
    return _FullNameDriver["default"];
  }
});
Object.defineProperty(exports, "FullNameDriverAllOf", {
  enumerable: true,
  get: function get() {
    return _FullNameDriverAllOf["default"];
  }
});
Object.defineProperty(exports, "GenesisAddress", {
  enumerable: true,
  get: function get() {
    return _GenesisAddress["default"];
  }
});
Object.defineProperty(exports, "GenesisQuote", {
  enumerable: true,
  get: function get() {
    return _GenesisQuote["default"];
  }
});
Object.defineProperty(exports, "GenesisShipmentOptions", {
  enumerable: true,
  get: function get() {
    return _GenesisShipmentOptions["default"];
  }
});
Object.defineProperty(exports, "GroupedEnum", {
  enumerable: true,
  get: function get() {
    return _GroupedEnum["default"];
  }
});
Object.defineProperty(exports, "GroupedEnumGroup", {
  enumerable: true,
  get: function get() {
    return _GroupedEnumGroup["default"];
  }
});
Object.defineProperty(exports, "GroupedEnumValue", {
  enumerable: true,
  get: function get() {
    return _GroupedEnumValue["default"];
  }
});
Object.defineProperty(exports, "GroupedShipmentTimelineEvents", {
  enumerable: true,
  get: function get() {
    return _GroupedShipmentTimelineEvents["default"];
  }
});
Object.defineProperty(exports, "Hazmat", {
  enumerable: true,
  get: function get() {
    return _Hazmat["default"];
  }
});
Object.defineProperty(exports, "HistoricalPriceSources", {
  enumerable: true,
  get: function get() {
    return _HistoricalPriceSources["default"];
  }
});
Object.defineProperty(exports, "HoursOfService", {
  enumerable: true,
  get: function get() {
    return _HoursOfService["default"];
  }
});
Object.defineProperty(exports, "HoursOfServiceRecords", {
  enumerable: true,
  get: function get() {
    return _HoursOfServiceRecords["default"];
  }
});
Object.defineProperty(exports, "HoursOfServiceResponse", {
  enumerable: true,
  get: function get() {
    return _HoursOfServiceResponse["default"];
  }
});
Object.defineProperty(exports, "IOSMinVersion", {
  enumerable: true,
  get: function get() {
    return _IOSMinVersion["default"];
  }
});
Object.defineProperty(exports, "IdentifyingCode", {
  enumerable: true,
  get: function get() {
    return _IdentifyingCode["default"];
  }
});
Object.defineProperty(exports, "IdentifyingCodeType", {
  enumerable: true,
  get: function get() {
    return _IdentifyingCodeType["default"];
  }
});
Object.defineProperty(exports, "ImpersonableTenant", {
  enumerable: true,
  get: function get() {
    return _ImpersonableTenant["default"];
  }
});
Object.defineProperty(exports, "ImpersonableTenants", {
  enumerable: true,
  get: function get() {
    return _ImpersonableTenants["default"];
  }
});
Object.defineProperty(exports, "ImpersonateUserResponse", {
  enumerable: true,
  get: function get() {
    return _ImpersonateUserResponse["default"];
  }
});
Object.defineProperty(exports, "ImpersonationTokenResponse", {
  enumerable: true,
  get: function get() {
    return _ImpersonationTokenResponse["default"];
  }
});
Object.defineProperty(exports, "ImportColumnMapping", {
  enumerable: true,
  get: function get() {
    return _ImportColumnMapping["default"];
  }
});
Object.defineProperty(exports, "ImportJob", {
  enumerable: true,
  get: function get() {
    return _ImportJob["default"];
  }
});
Object.defineProperty(exports, "ImportRow", {
  enumerable: true,
  get: function get() {
    return _ImportRow["default"];
  }
});
Object.defineProperty(exports, "ImportValue", {
  enumerable: true,
  get: function get() {
    return _ImportValue["default"];
  }
});
Object.defineProperty(exports, "InaccurateCarrier", {
  enumerable: true,
  get: function get() {
    return _InaccurateCarrier["default"];
  }
});
Object.defineProperty(exports, "InboxMessage", {
  enumerable: true,
  get: function get() {
    return _InboxMessage["default"];
  }
});
Object.defineProperty(exports, "InitiateCheckCallRequest", {
  enumerable: true,
  get: function get() {
    return _InitiateCheckCallRequest["default"];
  }
});
Object.defineProperty(exports, "InitiateOrderConsolidationRequest", {
  enumerable: true,
  get: function get() {
    return _InitiateOrderConsolidationRequest["default"];
  }
});
Object.defineProperty(exports, "InitiateRoutingGuideRequest", {
  enumerable: true,
  get: function get() {
    return _InitiateRoutingGuideRequest["default"];
  }
});
Object.defineProperty(exports, "InlineObject", {
  enumerable: true,
  get: function get() {
    return _InlineObject["default"];
  }
});
Object.defineProperty(exports, "InlineObject1", {
  enumerable: true,
  get: function get() {
    return _InlineObject2["default"];
  }
});
Object.defineProperty(exports, "InlineObject10", {
  enumerable: true,
  get: function get() {
    return _InlineObject3["default"];
  }
});
Object.defineProperty(exports, "InlineObject11", {
  enumerable: true,
  get: function get() {
    return _InlineObject4["default"];
  }
});
Object.defineProperty(exports, "InlineObject12", {
  enumerable: true,
  get: function get() {
    return _InlineObject5["default"];
  }
});
Object.defineProperty(exports, "InlineObject13", {
  enumerable: true,
  get: function get() {
    return _InlineObject6["default"];
  }
});
Object.defineProperty(exports, "InlineObject14", {
  enumerable: true,
  get: function get() {
    return _InlineObject7["default"];
  }
});
Object.defineProperty(exports, "InlineObject15", {
  enumerable: true,
  get: function get() {
    return _InlineObject8["default"];
  }
});
Object.defineProperty(exports, "InlineObject2", {
  enumerable: true,
  get: function get() {
    return _InlineObject9["default"];
  }
});
Object.defineProperty(exports, "InlineObject3", {
  enumerable: true,
  get: function get() {
    return _InlineObject10["default"];
  }
});
Object.defineProperty(exports, "InlineObject4", {
  enumerable: true,
  get: function get() {
    return _InlineObject11["default"];
  }
});
Object.defineProperty(exports, "InlineObject5", {
  enumerable: true,
  get: function get() {
    return _InlineObject12["default"];
  }
});
Object.defineProperty(exports, "InlineObject6", {
  enumerable: true,
  get: function get() {
    return _InlineObject13["default"];
  }
});
Object.defineProperty(exports, "InlineObject7", {
  enumerable: true,
  get: function get() {
    return _InlineObject14["default"];
  }
});
Object.defineProperty(exports, "InlineObject8", {
  enumerable: true,
  get: function get() {
    return _InlineObject15["default"];
  }
});
Object.defineProperty(exports, "InlineObject9", {
  enumerable: true,
  get: function get() {
    return _InlineObject16["default"];
  }
});
Object.defineProperty(exports, "InlineResponse200", {
  enumerable: true,
  get: function get() {
    return _InlineResponse["default"];
  }
});
Object.defineProperty(exports, "InlineResponse2001", {
  enumerable: true,
  get: function get() {
    return _InlineResponse2["default"];
  }
});
Object.defineProperty(exports, "InlineResponse2002", {
  enumerable: true,
  get: function get() {
    return _InlineResponse3["default"];
  }
});
Object.defineProperty(exports, "InlineResponse200ManagedContent", {
  enumerable: true,
  get: function get() {
    return _InlineResponse200ManagedContent["default"];
  }
});
Object.defineProperty(exports, "InlineResponse200ManagedContentDashboards", {
  enumerable: true,
  get: function get() {
    return _InlineResponse200ManagedContentDashboards["default"];
  }
});
Object.defineProperty(exports, "Invoice", {
  enumerable: true,
  get: function get() {
    return _Invoice["default"];
  }
});
Object.defineProperty(exports, "InvoiceCustomData", {
  enumerable: true,
  get: function get() {
    return _InvoiceCustomData["default"];
  }
});
Object.defineProperty(exports, "InvoiceEmailResponse", {
  enumerable: true,
  get: function get() {
    return _InvoiceEmailResponse["default"];
  }
});
Object.defineProperty(exports, "InvoiceEmailResponseInvoice", {
  enumerable: true,
  get: function get() {
    return _InvoiceEmailResponseInvoice["default"];
  }
});
Object.defineProperty(exports, "InvoiceLineItemCustomData", {
  enumerable: true,
  get: function get() {
    return _InvoiceLineItemCustomData["default"];
  }
});
Object.defineProperty(exports, "InvoiceLineItems", {
  enumerable: true,
  get: function get() {
    return _InvoiceLineItems["default"];
  }
});
Object.defineProperty(exports, "InvoiceUpdateRequest", {
  enumerable: true,
  get: function get() {
    return _InvoiceUpdateRequest["default"];
  }
});
Object.defineProperty(exports, "InvoicingShipmentsShipmentIdInvoicesLineItems", {
  enumerable: true,
  get: function get() {
    return _InvoicingShipmentsShipmentIdInvoicesLineItems["default"];
  }
});
Object.defineProperty(exports, "JobRole", {
  enumerable: true,
  get: function get() {
    return _JobRole["default"];
  }
});
Object.defineProperty(exports, "KeepTruckinCredentials", {
  enumerable: true,
  get: function get() {
    return _KeepTruckinCredentials["default"];
  }
});
Object.defineProperty(exports, "LegLocationResponse", {
  enumerable: true,
  get: function get() {
    return _LegLocationResponse["default"];
  }
});
Object.defineProperty(exports, "LegTag", {
  enumerable: true,
  get: function get() {
    return _LegTag["default"];
  }
});
Object.defineProperty(exports, "LegTag1", {
  enumerable: true,
  get: function get() {
    return _LegTag2["default"];
  }
});
Object.defineProperty(exports, "LetterOfReleaseDocument", {
  enumerable: true,
  get: function get() {
    return _LetterOfReleaseDocument["default"];
  }
});
Object.defineProperty(exports, "LinearFeetEstimate", {
  enumerable: true,
  get: function get() {
    return _LinearFeetEstimate["default"];
  }
});
Object.defineProperty(exports, "LinkDriver", {
  enumerable: true,
  get: function get() {
    return _LinkDriver["default"];
  }
});
Object.defineProperty(exports, "LinkQuoteToSpotNegotiationRequest", {
  enumerable: true,
  get: function get() {
    return _LinkQuoteToSpotNegotiationRequest["default"];
  }
});
Object.defineProperty(exports, "ListTriumphPayDocumentsSubmissionEmail", {
  enumerable: true,
  get: function get() {
    return _ListTriumphPayDocumentsSubmissionEmail["default"];
  }
});
Object.defineProperty(exports, "LoadBoardBiddingStatuses", {
  enumerable: true,
  get: function get() {
    return _LoadBoardBiddingStatuses["default"];
  }
});
Object.defineProperty(exports, "LoadBoardShipment", {
  enumerable: true,
  get: function get() {
    return _LoadBoardShipment["default"];
  }
});
Object.defineProperty(exports, "LoadBoardTenderStatuses", {
  enumerable: true,
  get: function get() {
    return _LoadBoardTenderStatuses["default"];
  }
});
Object.defineProperty(exports, "LoadCapacitySchedule", {
  enumerable: true,
  get: function get() {
    return _LoadCapacitySchedule["default"];
  }
});
Object.defineProperty(exports, "LocationCapacityAvailabilityResponse", {
  enumerable: true,
  get: function get() {
    return _LocationCapacityAvailabilityResponse["default"];
  }
});
Object.defineProperty(exports, "LocationCustomData", {
  enumerable: true,
  get: function get() {
    return _LocationCustomData["default"];
  }
});
Object.defineProperty(exports, "LocationRating", {
  enumerable: true,
  get: function get() {
    return _LocationRating["default"];
  }
});
Object.defineProperty(exports, "LocationTemplate", {
  enumerable: true,
  get: function get() {
    return _LocationTemplate["default"];
  }
});
Object.defineProperty(exports, "LocationType", {
  enumerable: true,
  get: function get() {
    return _LocationType["default"];
  }
});
Object.defineProperty(exports, "Login", {
  enumerable: true,
  get: function get() {
    return _Login["default"];
  }
});
Object.defineProperty(exports, "LoginResponse", {
  enumerable: true,
  get: function get() {
    return _LoginResponse["default"];
  }
});
Object.defineProperty(exports, "MagicLinkRequest", {
  enumerable: true,
  get: function get() {
    return _MagicLinkRequest["default"];
  }
});
Object.defineProperty(exports, "Markup", {
  enumerable: true,
  get: function get() {
    return _Markup["default"];
  }
});
Object.defineProperty(exports, "MeResponse", {
  enumerable: true,
  get: function get() {
    return _MeResponse["default"];
  }
});
Object.defineProperty(exports, "MessageListShipmentMessage", {
  enumerable: true,
  get: function get() {
    return _MessageListShipmentMessage["default"];
  }
});
Object.defineProperty(exports, "MileageException", {
  enumerable: true,
  get: function get() {
    return _MileageException["default"];
  }
});
Object.defineProperty(exports, "MileageType", {
  enumerable: true,
  get: function get() {
    return _MileageType["default"];
  }
});
Object.defineProperty(exports, "NMFC", {
  enumerable: true,
  get: function get() {
    return _NMFC["default"];
  }
});
Object.defineProperty(exports, "NetsuiteCategory", {
  enumerable: true,
  get: function get() {
    return _NetsuiteCategory["default"];
  }
});
Object.defineProperty(exports, "NetsuiteCategoryOptions", {
  enumerable: true,
  get: function get() {
    return _NetsuiteCategoryOptions["default"];
  }
});
Object.defineProperty(exports, "NetsuiteCompanyOptions", {
  enumerable: true,
  get: function get() {
    return _NetsuiteCompanyOptions["default"];
  }
});
Object.defineProperty(exports, "NetsuiteConfig", {
  enumerable: true,
  get: function get() {
    return _NetsuiteConfig["default"];
  }
});
Object.defineProperty(exports, "NetsuiteConfigCategoryMapping", {
  enumerable: true,
  get: function get() {
    return _NetsuiteConfigCategoryMapping["default"];
  }
});
Object.defineProperty(exports, "NetsuiteConfigCategoryMappings", {
  enumerable: true,
  get: function get() {
    return _NetsuiteConfigCategoryMappings["default"];
  }
});
Object.defineProperty(exports, "NetsuiteConfigFieldMappings", {
  enumerable: true,
  get: function get() {
    return _NetsuiteConfigFieldMappings["default"];
  }
});
Object.defineProperty(exports, "NetsuiteCustomField", {
  enumerable: true,
  get: function get() {
    return _NetsuiteCustomField["default"];
  }
});
Object.defineProperty(exports, "NetsuiteCustomFieldOptions", {
  enumerable: true,
  get: function get() {
    return _NetsuiteCustomFieldOptions["default"];
  }
});
Object.defineProperty(exports, "NetsuiteFieldOption", {
  enumerable: true,
  get: function get() {
    return _NetsuiteFieldOption["default"];
  }
});
Object.defineProperty(exports, "NoContentResponse", {
  enumerable: true,
  get: function get() {
    return _NoContentResponse["default"];
  }
});
Object.defineProperty(exports, "NotificationPreference", {
  enumerable: true,
  get: function get() {
    return _NotificationPreference["default"];
  }
});
Object.defineProperty(exports, "NotifyShipmentsNotTracking", {
  enumerable: true,
  get: function get() {
    return _NotifyShipmentsNotTracking["default"];
  }
});
Object.defineProperty(exports, "OpenCloseSpotNegotiationsRequest", {
  enumerable: true,
  get: function get() {
    return _OpenCloseSpotNegotiationsRequest["default"];
  }
});
Object.defineProperty(exports, "OperatingAuthority", {
  enumerable: true,
  get: function get() {
    return _OperatingAuthority["default"];
  }
});
Object.defineProperty(exports, "OrderConsolidationPolicyCustomer", {
  enumerable: true,
  get: function get() {
    return _OrderConsolidationPolicyCustomer["default"];
  }
});
Object.defineProperty(exports, "OrderConsolidationPolicyProduct", {
  enumerable: true,
  get: function get() {
    return _OrderConsolidationPolicyProduct["default"];
  }
});
Object.defineProperty(exports, "OrderConsolidationPolicySupplier", {
  enumerable: true,
  get: function get() {
    return _OrderConsolidationPolicySupplier["default"];
  }
});
Object.defineProperty(exports, "OverallStatusesResponse", {
  enumerable: true,
  get: function get() {
    return _OverallStatusesResponse["default"];
  }
});
Object.defineProperty(exports, "PackageType", {
  enumerable: true,
  get: function get() {
    return _PackageType["default"];
  }
});
Object.defineProperty(exports, "PaginatedAPIKeys", {
  enumerable: true,
  get: function get() {
    return _PaginatedAPIKeys["default"];
  }
});
Object.defineProperty(exports, "PaginatedAccessorialChargeTable", {
  enumerable: true,
  get: function get() {
    return _PaginatedAccessorialChargeTable["default"];
  }
});
Object.defineProperty(exports, "PaginatedAddressBookEntry", {
  enumerable: true,
  get: function get() {
    return _PaginatedAddressBookEntry["default"];
  }
});
Object.defineProperty(exports, "PaginatedAlertEvent", {
  enumerable: true,
  get: function get() {
    return _PaginatedAlertEvent["default"];
  }
});
Object.defineProperty(exports, "PaginatedAlertsDashBoardConfiguration", {
  enumerable: true,
  get: function get() {
    return _PaginatedAlertsDashBoardConfiguration["default"];
  }
});
Object.defineProperty(exports, "PaginatedAutomationEvent", {
  enumerable: true,
  get: function get() {
    return _PaginatedAutomationEvent["default"];
  }
});
Object.defineProperty(exports, "PaginatedBill", {
  enumerable: true,
  get: function get() {
    return _PaginatedBill["default"];
  }
});
Object.defineProperty(exports, "PaginatedCarrierBid", {
  enumerable: true,
  get: function get() {
    return _PaginatedCarrierBid["default"];
  }
});
Object.defineProperty(exports, "PaginatedCarrierBiddingSummaryShipment", {
  enumerable: true,
  get: function get() {
    return _PaginatedCarrierBiddingSummaryShipment["default"];
  }
});
Object.defineProperty(exports, "PaginatedCarrierCarrierCapacityRecord", {
  enumerable: true,
  get: function get() {
    return _PaginatedCarrierCarrierCapacityRecord["default"];
  }
});
Object.defineProperty(exports, "PaginatedCarrierPocTag", {
  enumerable: true,
  get: function get() {
    return _PaginatedCarrierPocTag["default"];
  }
});
Object.defineProperty(exports, "PaginatedCarrierTag", {
  enumerable: true,
  get: function get() {
    return _PaginatedCarrierTag["default"];
  }
});
Object.defineProperty(exports, "PaginatedCaseNote", {
  enumerable: true,
  get: function get() {
    return _PaginatedCaseNote["default"];
  }
});
Object.defineProperty(exports, "PaginatedCompany", {
  enumerable: true,
  get: function get() {
    return _PaginatedCompany["default"];
  }
});
Object.defineProperty(exports, "PaginatedContract", {
  enumerable: true,
  get: function get() {
    return _PaginatedContract["default"];
  }
});
Object.defineProperty(exports, "PaginatedCustomField", {
  enumerable: true,
  get: function get() {
    return _PaginatedCustomField["default"];
  }
});
Object.defineProperty(exports, "PaginatedDataImport", {
  enumerable: true,
  get: function get() {
    return _PaginatedDataImport["default"];
  }
});
Object.defineProperty(exports, "PaginatedDataImportError", {
  enumerable: true,
  get: function get() {
    return _PaginatedDataImportError["default"];
  }
});
Object.defineProperty(exports, "PaginatedDocumentMetadata", {
  enumerable: true,
  get: function get() {
    return _PaginatedDocumentMetadata["default"];
  }
});
Object.defineProperty(exports, "PaginatedDriver", {
  enumerable: true,
  get: function get() {
    return _PaginatedDriver["default"];
  }
});
Object.defineProperty(exports, "PaginatedDriverLog", {
  enumerable: true,
  get: function get() {
    return _PaginatedDriverLog["default"];
  }
});
Object.defineProperty(exports, "PaginatedDriverMessages", {
  enumerable: true,
  get: function get() {
    return _PaginatedDriverMessages["default"];
  }
});
Object.defineProperty(exports, "PaginatedEIAFuelRate", {
  enumerable: true,
  get: function get() {
    return _PaginatedEIAFuelRate["default"];
  }
});
Object.defineProperty(exports, "PaginatedFmcsaCarrier", {
  enumerable: true,
  get: function get() {
    return _PaginatedFmcsaCarrier["default"];
  }
});
Object.defineProperty(exports, "PaginatedFuelSurchargeTable", {
  enumerable: true,
  get: function get() {
    return _PaginatedFuelSurchargeTable["default"];
  }
});
Object.defineProperty(exports, "PaginatedImportColumnMapping", {
  enumerable: true,
  get: function get() {
    return _PaginatedImportColumnMapping["default"];
  }
});
Object.defineProperty(exports, "PaginatedImportJob", {
  enumerable: true,
  get: function get() {
    return _PaginatedImportJob["default"];
  }
});
Object.defineProperty(exports, "PaginatedImportRow", {
  enumerable: true,
  get: function get() {
    return _PaginatedImportRow["default"];
  }
});
Object.defineProperty(exports, "PaginatedInboxMessage", {
  enumerable: true,
  get: function get() {
    return _PaginatedInboxMessage["default"];
  }
});
Object.defineProperty(exports, "PaginatedInvoice", {
  enumerable: true,
  get: function get() {
    return _PaginatedInvoice["default"];
  }
});
Object.defineProperty(exports, "PaginatedInvoice1", {
  enumerable: true,
  get: function get() {
    return _PaginatedInvoice2["default"];
  }
});
Object.defineProperty(exports, "PaginatedLoadBoardShipment", {
  enumerable: true,
  get: function get() {
    return _PaginatedLoadBoardShipment["default"];
  }
});
Object.defineProperty(exports, "PaginatedPointOfContact", {
  enumerable: true,
  get: function get() {
    return _PaginatedPointOfContact["default"];
  }
});
Object.defineProperty(exports, "PaginatedPolicy", {
  enumerable: true,
  get: function get() {
    return _PaginatedPolicy["default"];
  }
});
Object.defineProperty(exports, "PaginatedPowerUnit", {
  enumerable: true,
  get: function get() {
    return _PaginatedPowerUnit["default"];
  }
});
Object.defineProperty(exports, "PaginatedProduct", {
  enumerable: true,
  get: function get() {
    return _PaginatedProduct["default"];
  }
});
Object.defineProperty(exports, "PaginatedPurchaseOrder", {
  enumerable: true,
  get: function get() {
    return _PaginatedPurchaseOrder["default"];
  }
});
Object.defineProperty(exports, "PaginatedPurchaseOrderLineItem", {
  enumerable: true,
  get: function get() {
    return _PaginatedPurchaseOrderLineItem["default"];
  }
});
Object.defineProperty(exports, "PaginatedPushNotification", {
  enumerable: true,
  get: function get() {
    return _PaginatedPushNotification["default"];
  }
});
Object.defineProperty(exports, "PaginatedQuickbooksBill", {
  enumerable: true,
  get: function get() {
    return _PaginatedQuickbooksBill["default"];
  }
});
Object.defineProperty(exports, "PaginatedQuickbooksExpenseClass", {
  enumerable: true,
  get: function get() {
    return _PaginatedQuickbooksExpenseClass["default"];
  }
});
Object.defineProperty(exports, "PaginatedQuickbooksExpensesCategoryMapping", {
  enumerable: true,
  get: function get() {
    return _PaginatedQuickbooksExpensesCategoryMapping["default"];
  }
});
Object.defineProperty(exports, "PaginatedQuickbooksGLAccount", {
  enumerable: true,
  get: function get() {
    return _PaginatedQuickbooksGLAccount["default"];
  }
});
Object.defineProperty(exports, "PaginatedQuickbooksItemCategoryMapping", {
  enumerable: true,
  get: function get() {
    return _PaginatedQuickbooksItemCategoryMapping["default"];
  }
});
Object.defineProperty(exports, "PaginatedQuickbooksItems", {
  enumerable: true,
  get: function get() {
    return _PaginatedQuickbooksItems["default"];
  }
});
Object.defineProperty(exports, "PaginatedQuote", {
  enumerable: true,
  get: function get() {
    return _PaginatedQuote["default"];
  }
});
Object.defineProperty(exports, "PaginatedRecordedELDProvider", {
  enumerable: true,
  get: function get() {
    return _PaginatedRecordedELDProvider["default"];
  }
});
Object.defineProperty(exports, "PaginatedRecordedEquipmentType", {
  enumerable: true,
  get: function get() {
    return _PaginatedRecordedEquipmentType["default"];
  }
});
Object.defineProperty(exports, "PaginatedRfpBid", {
  enumerable: true,
  get: function get() {
    return _PaginatedRfpBid["default"];
  }
});
Object.defineProperty(exports, "PaginatedRfpRow", {
  enumerable: true,
  get: function get() {
    return _PaginatedRfpRow["default"];
  }
});
Object.defineProperty(exports, "PaginatedServiceLevelAgreement", {
  enumerable: true,
  get: function get() {
    return _PaginatedServiceLevelAgreement["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipment", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipment["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentCase", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentCase["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentDocumentMetadata", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentDocumentMetadata["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentMessage", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentMessage["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentNote", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentNote["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentPickup", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentPickup["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentRep", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentRep["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentSpotNegotiation", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentSpotNegotiation["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentStopLocation", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentStopLocation["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentTag", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentTag["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipmentTimelineEvent", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipmentTimelineEvent["default"];
  }
});
Object.defineProperty(exports, "PaginatedShipperRelationship", {
  enumerable: true,
  get: function get() {
    return _PaginatedShipperRelationship["default"];
  }
});
Object.defineProperty(exports, "PaginatedSlimCarrierRelationship", {
  enumerable: true,
  get: function get() {
    return _PaginatedSlimCarrierRelationship["default"];
  }
});
Object.defineProperty(exports, "PaginatedSlimShipment", {
  enumerable: true,
  get: function get() {
    return _PaginatedSlimShipment["default"];
  }
});
Object.defineProperty(exports, "PaginatedSlimShipment1", {
  enumerable: true,
  get: function get() {
    return _PaginatedSlimShipment2["default"];
  }
});
Object.defineProperty(exports, "PaginatedSpotNegotiation", {
  enumerable: true,
  get: function get() {
    return _PaginatedSpotNegotiation["default"];
  }
});
Object.defineProperty(exports, "PaginatedSpotNegotiationMessage", {
  enumerable: true,
  get: function get() {
    return _PaginatedSpotNegotiationMessage["default"];
  }
});
Object.defineProperty(exports, "PaginatedSpotNegotiationQuote", {
  enumerable: true,
  get: function get() {
    return _PaginatedSpotNegotiationQuote["default"];
  }
});
Object.defineProperty(exports, "PaginatedStop", {
  enumerable: true,
  get: function get() {
    return _PaginatedStop["default"];
  }
});
Object.defineProperty(exports, "PaginatedStopAlert", {
  enumerable: true,
  get: function get() {
    return _PaginatedStopAlert["default"];
  }
});
Object.defineProperty(exports, "PaginatedSupplierInvite", {
  enumerable: true,
  get: function get() {
    return _PaginatedSupplierInvite["default"];
  }
});
Object.defineProperty(exports, "PaginatedTask", {
  enumerable: true,
  get: function get() {
    return _PaginatedTask["default"];
  }
});
Object.defineProperty(exports, "PaginatedTenders", {
  enumerable: true,
  get: function get() {
    return _PaginatedTenders["default"];
  }
});
Object.defineProperty(exports, "PaginatedTenders1", {
  enumerable: true,
  get: function get() {
    return _PaginatedTenders2["default"];
  }
});
Object.defineProperty(exports, "PaginatedTimelineEventTemplate", {
  enumerable: true,
  get: function get() {
    return _PaginatedTimelineEventTemplate["default"];
  }
});
Object.defineProperty(exports, "PaginatedTrackingNotificationConfig", {
  enumerable: true,
  get: function get() {
    return _PaginatedTrackingNotificationConfig["default"];
  }
});
Object.defineProperty(exports, "PaginatedTrailer", {
  enumerable: true,
  get: function get() {
    return _PaginatedTrailer["default"];
  }
});
Object.defineProperty(exports, "PaginatedTriumphPayVendorFactoringCompanyEntry", {
  enumerable: true,
  get: function get() {
    return _PaginatedTriumphPayVendorFactoringCompanyEntry["default"];
  }
});
Object.defineProperty(exports, "PaginatedTriumphPayVendors", {
  enumerable: true,
  get: function get() {
    return _PaginatedTriumphPayVendors["default"];
  }
});
Object.defineProperty(exports, "PaginatedUser", {
  enumerable: true,
  get: function get() {
    return _PaginatedUser["default"];
  }
});
Object.defineProperty(exports, "PaginatedUserDashboardConfiguration", {
  enumerable: true,
  get: function get() {
    return _PaginatedUserDashboardConfiguration["default"];
  }
});
Object.defineProperty(exports, "PaginatedVendorRelationship", {
  enumerable: true,
  get: function get() {
    return _PaginatedVendorRelationship["default"];
  }
});
Object.defineProperty(exports, "PaginatedWatchedShipment", {
  enumerable: true,
  get: function get() {
    return _PaginatedWatchedShipment["default"];
  }
});
Object.defineProperty(exports, "PaginatedWatchedShipmentResults", {
  enumerable: true,
  get: function get() {
    return _PaginatedWatchedShipmentResults["default"];
  }
});
Object.defineProperty(exports, "ParcelPickupStatus", {
  enumerable: true,
  get: function get() {
    return _ParcelPickupStatus["default"];
  }
});
Object.defineProperty(exports, "PaymentDefaultSuccessMessage", {
  enumerable: true,
  get: function get() {
    return _PaymentDefaultSuccessMessage["default"];
  }
});
Object.defineProperty(exports, "Permission", {
  enumerable: true,
  get: function get() {
    return _Permission["default"];
  }
});
Object.defineProperty(exports, "PermissionResponse", {
  enumerable: true,
  get: function get() {
    return _PermissionResponse["default"];
  }
});
Object.defineProperty(exports, "PhoneNumberLookup", {
  enumerable: true,
  get: function get() {
    return _PhoneNumberLookup["default"];
  }
});
Object.defineProperty(exports, "PickupPushResponse", {
  enumerable: true,
  get: function get() {
    return _PickupPushResponse["default"];
  }
});
Object.defineProperty(exports, "PieceType", {
  enumerable: true,
  get: function get() {
    return _PieceType["default"];
  }
});
Object.defineProperty(exports, "PointOfContact", {
  enumerable: true,
  get: function get() {
    return _PointOfContact["default"];
  }
});
Object.defineProperty(exports, "PointOfContactAllOf", {
  enumerable: true,
  get: function get() {
    return _PointOfContactAllOf["default"];
  }
});
Object.defineProperty(exports, "PointOfContactNotificationPreferences", {
  enumerable: true,
  get: function get() {
    return _PointOfContactNotificationPreferences["default"];
  }
});
Object.defineProperty(exports, "Policy", {
  enumerable: true,
  get: function get() {
    return _Policy["default"];
  }
});
Object.defineProperty(exports, "PolicyAsWorkflowTriggerConditional", {
  enumerable: true,
  get: function get() {
    return _PolicyAsWorkflowTriggerConditional["default"];
  }
});
Object.defineProperty(exports, "PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments", {
  enumerable: true,
  get: function get() {
    return _PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments["default"];
  }
});
Object.defineProperty(exports, "PostCompaniesCompanyidUsers", {
  enumerable: true,
  get: function get() {
    return _PostCompaniesCompanyidUsers["default"];
  }
});
Object.defineProperty(exports, "PostProducts", {
  enumerable: true,
  get: function get() {
    return _PostProducts["default"];
  }
});
Object.defineProperty(exports, "PostTriumphPayVendor", {
  enumerable: true,
  get: function get() {
    return _PostTriumphPayVendor["default"];
  }
});
Object.defineProperty(exports, "PowerUnit", {
  enumerable: true,
  get: function get() {
    return _PowerUnit["default"];
  }
});
Object.defineProperty(exports, "Product", {
  enumerable: true,
  get: function get() {
    return _Product["default"];
  }
});
Object.defineProperty(exports, "ProductAllOf", {
  enumerable: true,
  get: function get() {
    return _ProductAllOf["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrder", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrder["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderAlert", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderAlert["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderBuildShipmentAssemblyRequest", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderBuildShipmentAssemblyRequest["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderBuildShipmentRequest", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderBuildShipmentRequest["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderCustomData", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderCustomData["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderLineItem", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderLineItem["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderLineItemAllOf", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderLineItemAllOf["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderLineItemCustomData", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderLineItemCustomData["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderListResponse", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderListResponse["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderListResponseAllOf", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderListResponseAllOf["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderListScopedShipment", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderListScopedShipment["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderResponse", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderResponse["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderResponseAllOf", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderResponseAllOf["default"];
  }
});
Object.defineProperty(exports, "PurchaseOrderUpdateShipmentRequest", {
  enumerable: true,
  get: function get() {
    return _PurchaseOrderUpdateShipmentRequest["default"];
  }
});
Object.defineProperty(exports, "PushNotification", {
  enumerable: true,
  get: function get() {
    return _PushNotification["default"];
  }
});
Object.defineProperty(exports, "QuickbooksAuthDetails", {
  enumerable: true,
  get: function get() {
    return _QuickbooksAuthDetails["default"];
  }
});
Object.defineProperty(exports, "QuickbooksExpenseClass", {
  enumerable: true,
  get: function get() {
    return _QuickbooksExpenseClass["default"];
  }
});
Object.defineProperty(exports, "QuickbooksExpensesCategoryMapping", {
  enumerable: true,
  get: function get() {
    return _QuickbooksExpensesCategoryMapping["default"];
  }
});
Object.defineProperty(exports, "QuickbooksExpensesCategoryMappingExpenseAccount", {
  enumerable: true,
  get: function get() {
    return _QuickbooksExpensesCategoryMappingExpenseAccount["default"];
  }
});
Object.defineProperty(exports, "QuickbooksGLAccount", {
  enumerable: true,
  get: function get() {
    return _QuickbooksGLAccount["default"];
  }
});
Object.defineProperty(exports, "QuickbooksItem", {
  enumerable: true,
  get: function get() {
    return _QuickbooksItem["default"];
  }
});
Object.defineProperty(exports, "QuickbooksItemCategoryMapping", {
  enumerable: true,
  get: function get() {
    return _QuickbooksItemCategoryMapping["default"];
  }
});
Object.defineProperty(exports, "Quote", {
  enumerable: true,
  get: function get() {
    return _Quote["default"];
  }
});
Object.defineProperty(exports, "QuoteChargeLineItem", {
  enumerable: true,
  get: function get() {
    return _QuoteChargeLineItem["default"];
  }
});
Object.defineProperty(exports, "QuoteChargeLineItemAllOf", {
  enumerable: true,
  get: function get() {
    return _QuoteChargeLineItemAllOf["default"];
  }
});
Object.defineProperty(exports, "RFQ", {
  enumerable: true,
  get: function get() {
    return _RFQ["default"];
  }
});
Object.defineProperty(exports, "RFQAllOf", {
  enumerable: true,
  get: function get() {
    return _RFQAllOf["default"];
  }
});
Object.defineProperty(exports, "RMISAPIAccountRequest", {
  enumerable: true,
  get: function get() {
    return _RMISAPIAccountRequest["default"];
  }
});
Object.defineProperty(exports, "RMISAPIAccountResponse", {
  enumerable: true,
  get: function get() {
    return _RMISAPIAccountResponse["default"];
  }
});
Object.defineProperty(exports, "RMISAgreement", {
  enumerable: true,
  get: function get() {
    return _RMISAgreement["default"];
  }
});
Object.defineProperty(exports, "RMISCarrier", {
  enumerable: true,
  get: function get() {
    return _RMISCarrier["default"];
  }
});
Object.defineProperty(exports, "RMISCarrierCertificationStatus", {
  enumerable: true,
  get: function get() {
    return _RMISCarrierCertificationStatus["default"];
  }
});
Object.defineProperty(exports, "RMISCarrierPolicy", {
  enumerable: true,
  get: function get() {
    return _RMISCarrierPolicy["default"];
  }
});
Object.defineProperty(exports, "RMISCarrierProfile", {
  enumerable: true,
  get: function get() {
    return _RMISCarrierProfile["default"];
  }
});
Object.defineProperty(exports, "RMISClientCarrierAgreement", {
  enumerable: true,
  get: function get() {
    return _RMISClientCarrierAgreement["default"];
  }
});
Object.defineProperty(exports, "RMISClientCarrierAgreementRuleOverride", {
  enumerable: true,
  get: function get() {
    return _RMISClientCarrierAgreementRuleOverride["default"];
  }
});
Object.defineProperty(exports, "RMISContact", {
  enumerable: true,
  get: function get() {
    return _RMISContact["default"];
  }
});
Object.defineProperty(exports, "RMISCoverage", {
  enumerable: true,
  get: function get() {
    return _RMISCoverage["default"];
  }
});
Object.defineProperty(exports, "RMISCoverageDetails", {
  enumerable: true,
  get: function get() {
    return _RMISCoverageDetails["default"];
  }
});
Object.defineProperty(exports, "RMISCoverageLimits", {
  enumerable: true,
  get: function get() {
    return _RMISCoverageLimits["default"];
  }
});
Object.defineProperty(exports, "RMISDocument", {
  enumerable: true,
  get: function get() {
    return _RMISDocument["default"];
  }
});
Object.defineProperty(exports, "RMISDot", {
  enumerable: true,
  get: function get() {
    return _RMISDot["default"];
  }
});
Object.defineProperty(exports, "RMISDotSmsSafety", {
  enumerable: true,
  get: function get() {
    return _RMISDotSmsSafety["default"];
  }
});
Object.defineProperty(exports, "RMISDotTestingInfo", {
  enumerable: true,
  get: function get() {
    return _RMISDotTestingInfo["default"];
  }
});
Object.defineProperty(exports, "RMISEquipmentType", {
  enumerable: true,
  get: function get() {
    return _RMISEquipmentType["default"];
  }
});
Object.defineProperty(exports, "RMISFTPAccountRequest", {
  enumerable: true,
  get: function get() {
    return _RMISFTPAccountRequest["default"];
  }
});
Object.defineProperty(exports, "RMISFTPAccountResponse", {
  enumerable: true,
  get: function get() {
    return _RMISFTPAccountResponse["default"];
  }
});
Object.defineProperty(exports, "RMISJobStatus", {
  enumerable: true,
  get: function get() {
    return _RMISJobStatus["default"];
  }
});
Object.defineProperty(exports, "RMISNonCertifiedReason", {
  enumerable: true,
  get: function get() {
    return _RMISNonCertifiedReason["default"];
  }
});
Object.defineProperty(exports, "RMISOverride", {
  enumerable: true,
  get: function get() {
    return _RMISOverride["default"];
  }
});
Object.defineProperty(exports, "RMISW9", {
  enumerable: true,
  get: function get() {
    return _RMISW["default"];
  }
});
Object.defineProperty(exports, "RecordedELDProvider", {
  enumerable: true,
  get: function get() {
    return _RecordedELDProvider["default"];
  }
});
Object.defineProperty(exports, "RecordedEquipmentType", {
  enumerable: true,
  get: function get() {
    return _RecordedEquipmentType["default"];
  }
});
Object.defineProperty(exports, "RedirectUrl", {
  enumerable: true,
  get: function get() {
    return _RedirectUrl["default"];
  }
});
Object.defineProperty(exports, "RegisterFedex", {
  enumerable: true,
  get: function get() {
    return _RegisterFedex["default"];
  }
});
Object.defineProperty(exports, "RegisterFedexResponse", {
  enumerable: true,
  get: function get() {
    return _RegisterFedexResponse["default"];
  }
});
Object.defineProperty(exports, "RegisterFedexResponseAllOf", {
  enumerable: true,
  get: function get() {
    return _RegisterFedexResponseAllOf["default"];
  }
});
Object.defineProperty(exports, "RegisterUPS", {
  enumerable: true,
  get: function get() {
    return _RegisterUPS["default"];
  }
});
Object.defineProperty(exports, "RegisterUPSResponse", {
  enumerable: true,
  get: function get() {
    return _RegisterUPSResponse["default"];
  }
});
Object.defineProperty(exports, "RequestPasswordReset", {
  enumerable: true,
  get: function get() {
    return _RequestPasswordReset["default"];
  }
});
Object.defineProperty(exports, "RequestVerificationEmail", {
  enumerable: true,
  get: function get() {
    return _RequestVerificationEmail["default"];
  }
});
Object.defineProperty(exports, "ResetPassword", {
  enumerable: true,
  get: function get() {
    return _ResetPassword["default"];
  }
});
Object.defineProperty(exports, "ResetSignupInfo", {
  enumerable: true,
  get: function get() {
    return _ResetSignupInfo["default"];
  }
});
Object.defineProperty(exports, "RfpBidPostImportResults", {
  enumerable: true,
  get: function get() {
    return _RfpBidPostImportResults["default"];
  }
});
Object.defineProperty(exports, "RfpBidRequest", {
  enumerable: true,
  get: function get() {
    return _RfpBidRequest["default"];
  }
});
Object.defineProperty(exports, "RfpBidResponse", {
  enumerable: true,
  get: function get() {
    return _RfpBidResponse["default"];
  }
});
Object.defineProperty(exports, "RfpRowResponse", {
  enumerable: true,
  get: function get() {
    return _RfpRowResponse["default"];
  }
});
Object.defineProperty(exports, "SaferWatchAccountRequest", {
  enumerable: true,
  get: function get() {
    return _SaferWatchAccountRequest["default"];
  }
});
Object.defineProperty(exports, "SaferWatchAccountResponse", {
  enumerable: true,
  get: function get() {
    return _SaferWatchAccountResponse["default"];
  }
});
Object.defineProperty(exports, "SaferWatchAuthority", {
  enumerable: true,
  get: function get() {
    return _SaferWatchAuthority["default"];
  }
});
Object.defineProperty(exports, "SaferWatchCargo", {
  enumerable: true,
  get: function get() {
    return _SaferWatchCargo["default"];
  }
});
Object.defineProperty(exports, "SaferWatchCarrier", {
  enumerable: true,
  get: function get() {
    return _SaferWatchCarrier["default"];
  }
});
Object.defineProperty(exports, "SaferWatchCarrierPolicy", {
  enumerable: true,
  get: function get() {
    return _SaferWatchCarrierPolicy["default"];
  }
});
Object.defineProperty(exports, "SaferWatchCertData", {
  enumerable: true,
  get: function get() {
    return _SaferWatchCertData["default"];
  }
});
Object.defineProperty(exports, "SaferWatchCertificate", {
  enumerable: true,
  get: function get() {
    return _SaferWatchCertificate["default"];
  }
});
Object.defineProperty(exports, "SaferWatchCoverage", {
  enumerable: true,
  get: function get() {
    return _SaferWatchCoverage["default"];
  }
});
Object.defineProperty(exports, "SaferWatchCrash", {
  enumerable: true,
  get: function get() {
    return _SaferWatchCrash["default"];
  }
});
Object.defineProperty(exports, "SaferWatchDrivers", {
  enumerable: true,
  get: function get() {
    return _SaferWatchDrivers["default"];
  }
});
Object.defineProperty(exports, "SaferWatchEquipment", {
  enumerable: true,
  get: function get() {
    return _SaferWatchEquipment["default"];
  }
});
Object.defineProperty(exports, "SaferWatchFmcsaInsurance", {
  enumerable: true,
  get: function get() {
    return _SaferWatchFmcsaInsurance["default"];
  }
});
Object.defineProperty(exports, "SaferWatchIdentity", {
  enumerable: true,
  get: function get() {
    return _SaferWatchIdentity["default"];
  }
});
Object.defineProperty(exports, "SaferWatchInspection", {
  enumerable: true,
  get: function get() {
    return _SaferWatchInspection["default"];
  }
});
Object.defineProperty(exports, "SaferWatchJobStatus", {
  enumerable: true,
  get: function get() {
    return _SaferWatchJobStatus["default"];
  }
});
Object.defineProperty(exports, "SaferWatchOperation", {
  enumerable: true,
  get: function get() {
    return _SaferWatchOperation["default"];
  }
});
Object.defineProperty(exports, "SaferWatchOther", {
  enumerable: true,
  get: function get() {
    return _SaferWatchOther["default"];
  }
});
Object.defineProperty(exports, "SaferWatchPolicyItem", {
  enumerable: true,
  get: function get() {
    return _SaferWatchPolicyItem["default"];
  }
});
Object.defineProperty(exports, "SaferWatchReview", {
  enumerable: true,
  get: function get() {
    return _SaferWatchReview["default"];
  }
});
Object.defineProperty(exports, "SaferWatchRiskAssessment", {
  enumerable: true,
  get: function get() {
    return _SaferWatchRiskAssessment["default"];
  }
});
Object.defineProperty(exports, "SaferWatchSafety", {
  enumerable: true,
  get: function get() {
    return _SaferWatchSafety["default"];
  }
});
Object.defineProperty(exports, "ScheduleShipmentPickupRequest", {
  enumerable: true,
  get: function get() {
    return _ScheduleShipmentPickupRequest["default"];
  }
});
Object.defineProperty(exports, "SendDocument", {
  enumerable: true,
  get: function get() {
    return _SendDocument["default"];
  }
});
Object.defineProperty(exports, "ServiceLevel", {
  enumerable: true,
  get: function get() {
    return _ServiceLevel["default"];
  }
});
Object.defineProperty(exports, "ServiceLevelAgreement", {
  enumerable: true,
  get: function get() {
    return _ServiceLevelAgreement["default"];
  }
});
Object.defineProperty(exports, "ServiceLevelAgreementIntervals", {
  enumerable: true,
  get: function get() {
    return _ServiceLevelAgreementIntervals["default"];
  }
});
Object.defineProperty(exports, "ServiceLevelAgreementStatuses", {
  enumerable: true,
  get: function get() {
    return _ServiceLevelAgreementStatuses["default"];
  }
});
Object.defineProperty(exports, "SetPassword", {
  enumerable: true,
  get: function get() {
    return _SetPassword["default"];
  }
});
Object.defineProperty(exports, "ShareShipment", {
  enumerable: true,
  get: function get() {
    return _ShareShipment["default"];
  }
});
Object.defineProperty(exports, "Shipment", {
  enumerable: true,
  get: function get() {
    return _Shipment["default"];
  }
});
Object.defineProperty(exports, "ShipmentAlertLevel", {
  enumerable: true,
  get: function get() {
    return _ShipmentAlertLevel["default"];
  }
});
Object.defineProperty(exports, "ShipmentAllOf", {
  enumerable: true,
  get: function get() {
    return _ShipmentAllOf["default"];
  }
});
Object.defineProperty(exports, "ShipmentCase", {
  enumerable: true,
  get: function get() {
    return _ShipmentCase["default"];
  }
});
Object.defineProperty(exports, "ShipmentChargeLineItem", {
  enumerable: true,
  get: function get() {
    return _ShipmentChargeLineItem["default"];
  }
});
Object.defineProperty(exports, "ShipmentChargeLineItemAllOf", {
  enumerable: true,
  get: function get() {
    return _ShipmentChargeLineItemAllOf["default"];
  }
});
Object.defineProperty(exports, "ShipmentChargeLineItemTemplate", {
  enumerable: true,
  get: function get() {
    return _ShipmentChargeLineItemTemplate["default"];
  }
});
Object.defineProperty(exports, "ShipmentCustomData", {
  enumerable: true,
  get: function get() {
    return _ShipmentCustomData["default"];
  }
});
Object.defineProperty(exports, "ShipmentDocumentMetadata", {
  enumerable: true,
  get: function get() {
    return _ShipmentDocumentMetadata["default"];
  }
});
Object.defineProperty(exports, "ShipmentDocumentMetadataAllOf", {
  enumerable: true,
  get: function get() {
    return _ShipmentDocumentMetadataAllOf["default"];
  }
});
Object.defineProperty(exports, "ShipmentLineItem", {
  enumerable: true,
  get: function get() {
    return _ShipmentLineItem["default"];
  }
});
Object.defineProperty(exports, "ShipmentLineItemAllOf", {
  enumerable: true,
  get: function get() {
    return _ShipmentLineItemAllOf["default"];
  }
});
Object.defineProperty(exports, "ShipmentLineItemCustomData", {
  enumerable: true,
  get: function get() {
    return _ShipmentLineItemCustomData["default"];
  }
});
Object.defineProperty(exports, "ShipmentLocationResponse", {
  enumerable: true,
  get: function get() {
    return _ShipmentLocationResponse["default"];
  }
});
Object.defineProperty(exports, "ShipmentMessage", {
  enumerable: true,
  get: function get() {
    return _ShipmentMessage["default"];
  }
});
Object.defineProperty(exports, "ShipmentMetadata", {
  enumerable: true,
  get: function get() {
    return _ShipmentMetadata["default"];
  }
});
Object.defineProperty(exports, "ShipmentMetadataCustomData", {
  enumerable: true,
  get: function get() {
    return _ShipmentMetadataCustomData["default"];
  }
});
Object.defineProperty(exports, "ShipmentMode", {
  enumerable: true,
  get: function get() {
    return _ShipmentMode["default"];
  }
});
Object.defineProperty(exports, "ShipmentModeStatus", {
  enumerable: true,
  get: function get() {
    return _ShipmentModeStatus["default"];
  }
});
Object.defineProperty(exports, "ShipmentNote", {
  enumerable: true,
  get: function get() {
    return _ShipmentNote["default"];
  }
});
Object.defineProperty(exports, "ShipmentPickup", {
  enumerable: true,
  get: function get() {
    return _ShipmentPickup["default"];
  }
});
Object.defineProperty(exports, "ShipmentPickupAllOf", {
  enumerable: true,
  get: function get() {
    return _ShipmentPickupAllOf["default"];
  }
});
Object.defineProperty(exports, "ShipmentPosition", {
  enumerable: true,
  get: function get() {
    return _ShipmentPosition["default"];
  }
});
Object.defineProperty(exports, "ShipmentRep", {
  enumerable: true,
  get: function get() {
    return _ShipmentRep["default"];
  }
});
Object.defineProperty(exports, "ShipmentRepRole", {
  enumerable: true,
  get: function get() {
    return _ShipmentRepRole["default"];
  }
});
Object.defineProperty(exports, "ShipmentSpotNegotiation", {
  enumerable: true,
  get: function get() {
    return _ShipmentSpotNegotiation["default"];
  }
});
Object.defineProperty(exports, "ShipmentState", {
  enumerable: true,
  get: function get() {
    return _ShipmentState["default"];
  }
});
Object.defineProperty(exports, "ShipmentStatusEnum", {
  enumerable: true,
  get: function get() {
    return _ShipmentStatusEnum["default"];
  }
});
Object.defineProperty(exports, "ShipmentStopTemplate", {
  enumerable: true,
  get: function get() {
    return _ShipmentStopTemplate["default"];
  }
});
Object.defineProperty(exports, "ShipmentTag", {
  enumerable: true,
  get: function get() {
    return _ShipmentTag["default"];
  }
});
Object.defineProperty(exports, "ShipmentTemplate", {
  enumerable: true,
  get: function get() {
    return _ShipmentTemplate["default"];
  }
});
Object.defineProperty(exports, "ShipmentTimelineEvent", {
  enumerable: true,
  get: function get() {
    return _ShipmentTimelineEvent["default"];
  }
});
Object.defineProperty(exports, "ShipmentTimelineEventCustomData", {
  enumerable: true,
  get: function get() {
    return _ShipmentTimelineEventCustomData["default"];
  }
});
Object.defineProperty(exports, "ShipmentTimelineFilterPreferences", {
  enumerable: true,
  get: function get() {
    return _ShipmentTimelineFilterPreferences["default"];
  }
});
Object.defineProperty(exports, "Shipper", {
  enumerable: true,
  get: function get() {
    return _Shipper["default"];
  }
});
Object.defineProperty(exports, "ShipperRelationship", {
  enumerable: true,
  get: function get() {
    return _ShipperRelationship["default"];
  }
});
Object.defineProperty(exports, "ShipwellError", {
  enumerable: true,
  get: function get() {
    return _ShipwellError["default"];
  }
});
Object.defineProperty(exports, "ShipwellErrorFieldErrorsCondensed", {
  enumerable: true,
  get: function get() {
    return _ShipwellErrorFieldErrorsCondensed["default"];
  }
});
Object.defineProperty(exports, "ShopifyLogin", {
  enumerable: true,
  get: function get() {
    return _ShopifyLogin["default"];
  }
});
Object.defineProperty(exports, "ShopifyLoginAllOf", {
  enumerable: true,
  get: function get() {
    return _ShopifyLoginAllOf["default"];
  }
});
Object.defineProperty(exports, "ShopifySettings", {
  enumerable: true,
  get: function get() {
    return _ShopifySettings["default"];
  }
});
Object.defineProperty(exports, "SlimCarrierAssignment", {
  enumerable: true,
  get: function get() {
    return _SlimCarrierAssignment["default"];
  }
});
Object.defineProperty(exports, "SlimCarrierAssignmentAllOf", {
  enumerable: true,
  get: function get() {
    return _SlimCarrierAssignmentAllOf["default"];
  }
});
Object.defineProperty(exports, "SlimCarrierRelationship", {
  enumerable: true,
  get: function get() {
    return _SlimCarrierRelationship["default"];
  }
});
Object.defineProperty(exports, "SlimCarrierRelationshipAllOf", {
  enumerable: true,
  get: function get() {
    return _SlimCarrierRelationshipAllOf["default"];
  }
});
Object.defineProperty(exports, "SlimCarrierStatusCarrierAssignment", {
  enumerable: true,
  get: function get() {
    return _SlimCarrierStatusCarrierAssignment["default"];
  }
});
Object.defineProperty(exports, "SlimCompany", {
  enumerable: true,
  get: function get() {
    return _SlimCompany["default"];
  }
});
Object.defineProperty(exports, "SlimDriver", {
  enumerable: true,
  get: function get() {
    return _SlimDriver["default"];
  }
});
Object.defineProperty(exports, "SlimPurchaseOrder", {
  enumerable: true,
  get: function get() {
    return _SlimPurchaseOrder["default"];
  }
});
Object.defineProperty(exports, "SlimRFQ", {
  enumerable: true,
  get: function get() {
    return _SlimRFQ["default"];
  }
});
Object.defineProperty(exports, "SlimRMISCarrier", {
  enumerable: true,
  get: function get() {
    return _SlimRMISCarrier["default"];
  }
});
Object.defineProperty(exports, "SlimRMISCarrierStatus", {
  enumerable: true,
  get: function get() {
    return _SlimRMISCarrierStatus["default"];
  }
});
Object.defineProperty(exports, "SlimRMISCoverage", {
  enumerable: true,
  get: function get() {
    return _SlimRMISCoverage["default"];
  }
});
Object.defineProperty(exports, "SlimRMISCoverageLimit", {
  enumerable: true,
  get: function get() {
    return _SlimRMISCoverageLimit["default"];
  }
});
Object.defineProperty(exports, "SlimRMISDot", {
  enumerable: true,
  get: function get() {
    return _SlimRMISDot["default"];
  }
});
Object.defineProperty(exports, "SlimRMISDotTestingInfo", {
  enumerable: true,
  get: function get() {
    return _SlimRMISDotTestingInfo["default"];
  }
});
Object.defineProperty(exports, "SlimRMISJobStatus", {
  enumerable: true,
  get: function get() {
    return _SlimRMISJobStatus["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchAuthority", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchAuthority["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchCarrier", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchCarrier["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchCarrierStatus", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchCarrierStatus["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchCertData", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchCertData["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchCoverage", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchCoverage["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchFMCSAInsurance", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchFMCSAInsurance["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchOperation", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchOperation["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchPolicyItem", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchPolicyItem["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchReview", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchReview["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchRiskAssessment", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchRiskAssessment["default"];
  }
});
Object.defineProperty(exports, "SlimSaferWatchSafety", {
  enumerable: true,
  get: function get() {
    return _SlimSaferWatchSafety["default"];
  }
});
Object.defineProperty(exports, "SlimShipment", {
  enumerable: true,
  get: function get() {
    return _SlimShipment["default"];
  }
});
Object.defineProperty(exports, "SlimShipmentAllOf", {
  enumerable: true,
  get: function get() {
    return _SlimShipmentAllOf["default"];
  }
});
Object.defineProperty(exports, "SlimShipmentLineItem", {
  enumerable: true,
  get: function get() {
    return _SlimShipmentLineItem["default"];
  }
});
Object.defineProperty(exports, "SlimStop", {
  enumerable: true,
  get: function get() {
    return _SlimStop["default"];
  }
});
Object.defineProperty(exports, "SlimUser", {
  enumerable: true,
  get: function get() {
    return _SlimUser["default"];
  }
});
Object.defineProperty(exports, "SpotNegotiation", {
  enumerable: true,
  get: function get() {
    return _SpotNegotiation["default"];
  }
});
Object.defineProperty(exports, "SpotNegotiationMessage", {
  enumerable: true,
  get: function get() {
    return _SpotNegotiationMessage["default"];
  }
});
Object.defineProperty(exports, "SpotNegotiationPreview", {
  enumerable: true,
  get: function get() {
    return _SpotNegotiationPreview["default"];
  }
});
Object.defineProperty(exports, "SpotNegotiationQuoteInfo", {
  enumerable: true,
  get: function get() {
    return _SpotNegotiationQuoteInfo["default"];
  }
});
Object.defineProperty(exports, "Stop", {
  enumerable: true,
  get: function get() {
    return _Stop["default"];
  }
});
Object.defineProperty(exports, "StopAlert", {
  enumerable: true,
  get: function get() {
    return _StopAlert["default"];
  }
});
Object.defineProperty(exports, "StopCustomData", {
  enumerable: true,
  get: function get() {
    return _StopCustomData["default"];
  }
});
Object.defineProperty(exports, "StopEvent", {
  enumerable: true,
  get: function get() {
    return _StopEvent["default"];
  }
});
Object.defineProperty(exports, "StopLocation", {
  enumerable: true,
  get: function get() {
    return _StopLocation["default"];
  }
});
Object.defineProperty(exports, "StopPointOfContactTemplate", {
  enumerable: true,
  get: function get() {
    return _StopPointOfContactTemplate["default"];
  }
});
Object.defineProperty(exports, "SupplierInvite", {
  enumerable: true,
  get: function get() {
    return _SupplierInvite["default"];
  }
});
Object.defineProperty(exports, "SupplierInviteResponse", {
  enumerable: true,
  get: function get() {
    return _SupplierInviteResponse["default"];
  }
});
Object.defineProperty(exports, "SupplierInviteResponseAllOf", {
  enumerable: true,
  get: function get() {
    return _SupplierInviteResponseAllOf["default"];
  }
});
Object.defineProperty(exports, "Task", {
  enumerable: true,
  get: function get() {
    return _Task["default"];
  }
});
Object.defineProperty(exports, "TeletracCredentials", {
  enumerable: true,
  get: function get() {
    return _TeletracCredentials["default"];
  }
});
Object.defineProperty(exports, "TenderAcceptReject", {
  enumerable: true,
  get: function get() {
    return _TenderAcceptReject["default"];
  }
});
Object.defineProperty(exports, "TenderAcceptRejectDetails", {
  enumerable: true,
  get: function get() {
    return _TenderAcceptRejectDetails["default"];
  }
});
Object.defineProperty(exports, "TenderAppointmentEventRequest", {
  enumerable: true,
  get: function get() {
    return _TenderAppointmentEventRequest["default"];
  }
});
Object.defineProperty(exports, "TenderBase", {
  enumerable: true,
  get: function get() {
    return _TenderBase["default"];
  }
});
Object.defineProperty(exports, "TenderChargeLineItem", {
  enumerable: true,
  get: function get() {
    return _TenderChargeLineItem["default"];
  }
});
Object.defineProperty(exports, "TenderCreate", {
  enumerable: true,
  get: function get() {
    return _TenderCreate["default"];
  }
});
Object.defineProperty(exports, "TenderCreateAllOf", {
  enumerable: true,
  get: function get() {
    return _TenderCreateAllOf["default"];
  }
});
Object.defineProperty(exports, "TenderEmailPreview", {
  enumerable: true,
  get: function get() {
    return _TenderEmailPreview["default"];
  }
});
Object.defineProperty(exports, "TenderEquipmentEventRequest", {
  enumerable: true,
  get: function get() {
    return _TenderEquipmentEventRequest["default"];
  }
});
Object.defineProperty(exports, "TenderEtaEventRequest", {
  enumerable: true,
  get: function get() {
    return _TenderEtaEventRequest["default"];
  }
});
Object.defineProperty(exports, "TenderEventRequest", {
  enumerable: true,
  get: function get() {
    return _TenderEventRequest["default"];
  }
});
Object.defineProperty(exports, "TenderEventRequestEvents", {
  enumerable: true,
  get: function get() {
    return _TenderEventRequestEvents["default"];
  }
});
Object.defineProperty(exports, "TenderExternalEDISystem", {
  enumerable: true,
  get: function get() {
    return _TenderExternalEDISystem["default"];
  }
});
Object.defineProperty(exports, "TenderGet", {
  enumerable: true,
  get: function get() {
    return _TenderGet["default"];
  }
});
Object.defineProperty(exports, "TenderGetAllOf", {
  enumerable: true,
  get: function get() {
    return _TenderGetAllOf["default"];
  }
});
Object.defineProperty(exports, "TenderLocationEventRequest", {
  enumerable: true,
  get: function get() {
    return _TenderLocationEventRequest["default"];
  }
});
Object.defineProperty(exports, "TenderLocationEventRequestGeoLocation", {
  enumerable: true,
  get: function get() {
    return _TenderLocationEventRequestGeoLocation["default"];
  }
});
Object.defineProperty(exports, "TenderRejectRequest", {
  enumerable: true,
  get: function get() {
    return _TenderRejectRequest["default"];
  }
});
Object.defineProperty(exports, "TenderRequest", {
  enumerable: true,
  get: function get() {
    return _TenderRequest["default"];
  }
});
Object.defineProperty(exports, "TenderRequestCharge", {
  enumerable: true,
  get: function get() {
    return _TenderRequestCharge["default"];
  }
});
Object.defineProperty(exports, "TenderRequestCustomer", {
  enumerable: true,
  get: function get() {
    return _TenderRequestCustomer["default"];
  }
});
Object.defineProperty(exports, "TenderRequestEquipment", {
  enumerable: true,
  get: function get() {
    return _TenderRequestEquipment["default"];
  }
});
Object.defineProperty(exports, "TenderRequestEquipmentTemperatureControl", {
  enumerable: true,
  get: function get() {
    return _TenderRequestEquipmentTemperatureControl["default"];
  }
});
Object.defineProperty(exports, "TenderRequestLength", {
  enumerable: true,
  get: function get() {
    return _TenderRequestLength["default"];
  }
});
Object.defineProperty(exports, "TenderRequestShipment", {
  enumerable: true,
  get: function get() {
    return _TenderRequestShipment["default"];
  }
});
Object.defineProperty(exports, "TenderRequestShipmentStop", {
  enumerable: true,
  get: function get() {
    return _TenderRequestShipmentStop["default"];
  }
});
Object.defineProperty(exports, "TenderRequestShipmentStopAddress", {
  enumerable: true,
  get: function get() {
    return _TenderRequestShipmentStopAddress["default"];
  }
});
Object.defineProperty(exports, "TenderRequestShipmentStopContact", {
  enumerable: true,
  get: function get() {
    return _TenderRequestShipmentStopContact["default"];
  }
});
Object.defineProperty(exports, "TenderRequestShipmentStopLineItem", {
  enumerable: true,
  get: function get() {
    return _TenderRequestShipmentStopLineItem["default"];
  }
});
Object.defineProperty(exports, "TenderRequestTemperature", {
  enumerable: true,
  get: function get() {
    return _TenderRequestTemperature["default"];
  }
});
Object.defineProperty(exports, "TenderRequestVendor", {
  enumerable: true,
  get: function get() {
    return _TenderRequestVendor["default"];
  }
});
Object.defineProperty(exports, "TenderRequestWeight", {
  enumerable: true,
  get: function get() {
    return _TenderRequestWeight["default"];
  }
});
Object.defineProperty(exports, "TenderShipmentStateEventRequest", {
  enumerable: true,
  get: function get() {
    return _TenderShipmentStateEventRequest["default"];
  }
});
Object.defineProperty(exports, "TenderStopLocationEventRequest", {
  enumerable: true,
  get: function get() {
    return _TenderStopLocationEventRequest["default"];
  }
});
Object.defineProperty(exports, "TextMessageTemplates", {
  enumerable: true,
  get: function get() {
    return _TextMessageTemplates["default"];
  }
});
Object.defineProperty(exports, "TimelineEventTemplate", {
  enumerable: true,
  get: function get() {
    return _TimelineEventTemplate["default"];
  }
});
Object.defineProperty(exports, "TokenResponse", {
  enumerable: true,
  get: function get() {
    return _TokenResponse["default"];
  }
});
Object.defineProperty(exports, "TotalWeightOverride", {
  enumerable: true,
  get: function get() {
    return _TotalWeightOverride["default"];
  }
});
Object.defineProperty(exports, "TrackingNotificationConfig", {
  enumerable: true,
  get: function get() {
    return _TrackingNotificationConfig["default"];
  }
});
Object.defineProperty(exports, "Trailer", {
  enumerable: true,
  get: function get() {
    return _Trailer["default"];
  }
});
Object.defineProperty(exports, "TriumphPayApprovedDateSource", {
  enumerable: true,
  get: function get() {
    return _TriumphPayApprovedDateSource["default"];
  }
});
Object.defineProperty(exports, "TriumphPayAuthDetails", {
  enumerable: true,
  get: function get() {
    return _TriumphPayAuthDetails["default"];
  }
});
Object.defineProperty(exports, "TriumphPayAuthSettings", {
  enumerable: true,
  get: function get() {
    return _TriumphPayAuthSettings["default"];
  }
});
Object.defineProperty(exports, "TriumphPayCarrierInvoice", {
  enumerable: true,
  get: function get() {
    return _TriumphPayCarrierInvoice["default"];
  }
});
Object.defineProperty(exports, "TriumphPayCarrierPaymentAccount", {
  enumerable: true,
  get: function get() {
    return _TriumphPayCarrierPaymentAccount["default"];
  }
});
Object.defineProperty(exports, "TriumphPayCarrierPaymentAccountMailCheckData", {
  enumerable: true,
  get: function get() {
    return _TriumphPayCarrierPaymentAccountMailCheckData["default"];
  }
});
Object.defineProperty(exports, "TriumphPayCarrierSyncedInvoice", {
  enumerable: true,
  get: function get() {
    return _TriumphPayCarrierSyncedInvoice["default"];
  }
});
Object.defineProperty(exports, "TriumphPayDocumentsSubmissionEmail", {
  enumerable: true,
  get: function get() {
    return _TriumphPayDocumentsSubmissionEmail["default"];
  }
});
Object.defineProperty(exports, "TriumphPayPaymentAccountTypes", {
  enumerable: true,
  get: function get() {
    return _TriumphPayPaymentAccountTypes["default"];
  }
});
Object.defineProperty(exports, "TriumphPayVendor", {
  enumerable: true,
  get: function get() {
    return _TriumphPayVendor["default"];
  }
});
Object.defineProperty(exports, "TriumphPayVendorConnectionEstablishedSuccessMessage", {
  enumerable: true,
  get: function get() {
    return _TriumphPayVendorConnectionEstablishedSuccessMessage["default"];
  }
});
Object.defineProperty(exports, "TriumphPayVendorFreightAuthorityVendorRelationshipDetails", {
  enumerable: true,
  get: function get() {
    return _TriumphPayVendorFreightAuthorityVendorRelationshipDetails["default"];
  }
});
Object.defineProperty(exports, "TriumphPayVendorPaymentAccountData", {
  enumerable: true,
  get: function get() {
    return _TriumphPayVendorPaymentAccountData["default"];
  }
});
Object.defineProperty(exports, "TriumphPayVendorPaymentAccountDataBankAccountData", {
  enumerable: true,
  get: function get() {
    return _TriumphPayVendorPaymentAccountDataBankAccountData["default"];
  }
});
Object.defineProperty(exports, "TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocuments", {
  enumerable: true,
  get: function get() {
    return _TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocuments["default"];
  }
});
Object.defineProperty(exports, "TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocumentsAllOf", {
  enumerable: true,
  get: function get() {
    return _TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocumentsAllOf["default"];
  }
});
Object.defineProperty(exports, "UPSAccount", {
  enumerable: true,
  get: function get() {
    return _UPSAccount["default"];
  }
});
Object.defineProperty(exports, "UPSDirectQuote", {
  enumerable: true,
  get: function get() {
    return _UPSDirectQuote["default"];
  }
});
Object.defineProperty(exports, "UPSPackaging", {
  enumerable: true,
  get: function get() {
    return _UPSPackaging["default"];
  }
});
Object.defineProperty(exports, "UPSShipmentOptions", {
  enumerable: true,
  get: function get() {
    return _UPSShipmentOptions["default"];
  }
});
Object.defineProperty(exports, "UPSShipmentOptionsAllOf", {
  enumerable: true,
  get: function get() {
    return _UPSShipmentOptionsAllOf["default"];
  }
});
Object.defineProperty(exports, "USPSAccount", {
  enumerable: true,
  get: function get() {
    return _USPSAccount["default"];
  }
});
Object.defineProperty(exports, "USPSDirectQuote", {
  enumerable: true,
  get: function get() {
    return _USPSDirectQuote["default"];
  }
});
Object.defineProperty(exports, "USPSPackaging", {
  enumerable: true,
  get: function get() {
    return _USPSPackaging["default"];
  }
});
Object.defineProperty(exports, "USPSShipmentOptions", {
  enumerable: true,
  get: function get() {
    return _USPSShipmentOptions["default"];
  }
});
Object.defineProperty(exports, "USPSShipmentOptionsAllOf", {
  enumerable: true,
  get: function get() {
    return _USPSShipmentOptionsAllOf["default"];
  }
});
Object.defineProperty(exports, "UpdateShipmentRepRequest", {
  enumerable: true,
  get: function get() {
    return _UpdateShipmentRepRequest["default"];
  }
});
Object.defineProperty(exports, "UpdatedInsuranceRequest", {
  enumerable: true,
  get: function get() {
    return _UpdatedInsuranceRequest["default"];
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function get() {
    return _User["default"];
  }
});
Object.defineProperty(exports, "UserCustomData", {
  enumerable: true,
  get: function get() {
    return _UserCustomData["default"];
  }
});
Object.defineProperty(exports, "UserDashboardConfiguration", {
  enumerable: true,
  get: function get() {
    return _UserDashboardConfiguration["default"];
  }
});
Object.defineProperty(exports, "UserDashboardConfigurationConfig", {
  enumerable: true,
  get: function get() {
    return _UserDashboardConfigurationConfig["default"];
  }
});
Object.defineProperty(exports, "UserPreferences", {
  enumerable: true,
  get: function get() {
    return _UserPreferences["default"];
  }
});
Object.defineProperty(exports, "ValidatedAddress", {
  enumerable: true,
  get: function get() {
    return _ValidatedAddress["default"];
  }
});
Object.defineProperty(exports, "VehicleLocation", {
  enumerable: true,
  get: function get() {
    return _VehicleLocation["default"];
  }
});
Object.defineProperty(exports, "VehicleLocationAllOf", {
  enumerable: true,
  get: function get() {
    return _VehicleLocationAllOf["default"];
  }
});
Object.defineProperty(exports, "Vendor", {
  enumerable: true,
  get: function get() {
    return _Vendor["default"];
  }
});
Object.defineProperty(exports, "VendorFactoringCompany", {
  enumerable: true,
  get: function get() {
    return _VendorFactoringCompany["default"];
  }
});
Object.defineProperty(exports, "VendorRelationship", {
  enumerable: true,
  get: function get() {
    return _VendorRelationship["default"];
  }
});
Object.defineProperty(exports, "VerificationResponse", {
  enumerable: true,
  get: function get() {
    return _VerificationResponse["default"];
  }
});
Object.defineProperty(exports, "VerifyEmail", {
  enumerable: true,
  get: function get() {
    return _VerifyEmail["default"];
  }
});
Object.defineProperty(exports, "Versions", {
  enumerable: true,
  get: function get() {
    return _Versions["default"];
  }
});
Object.defineProperty(exports, "WorkflowAutomationStructuredConditional", {
  enumerable: true,
  get: function get() {
    return _WorkflowAutomationStructuredConditional["default"];
  }
});

var _ApiClient = _interopRequireDefault(require("./ApiClient"));

var _AbstractChargeLineItem = _interopRequireDefault(require("./model/AbstractChargeLineItem"));

var _Accessorial = _interopRequireDefault(require("./model/Accessorial"));

var _AccessorialChargeTable = _interopRequireDefault(require("./model/AccessorialChargeTable"));

var _AccessorialChargeTableCalculationRow = _interopRequireDefault(require("./model/AccessorialChargeTableCalculationRow"));

var _Address = _interopRequireDefault(require("./model/Address"));

var _AddressBookEntry = _interopRequireDefault(require("./model/AddressBookEntry"));

var _AddressTemplate = _interopRequireDefault(require("./model/AddressTemplate"));

var _AlertDashboardSlimCarrierRelationship = _interopRequireDefault(require("./model/AlertDashboardSlimCarrierRelationship"));

var _AlertDashboardSlimCarrierRelationshipCarrier = _interopRequireDefault(require("./model/AlertDashboardSlimCarrierRelationshipCarrier"));

var _AlertDashboardSlimShipment = _interopRequireDefault(require("./model/AlertDashboardSlimShipment"));

var _AlertEvent = _interopRequireDefault(require("./model/AlertEvent"));

var _AlertsDashBoardConfiguration = _interopRequireDefault(require("./model/AlertsDashBoardConfiguration"));

var _AlertsDashBoardConfigurationOptions = _interopRequireDefault(require("./model/AlertsDashBoardConfigurationOptions"));

var _AlertsDashBoardConfigurationOptionsThresholdDefinition = _interopRequireDefault(require("./model/AlertsDashBoardConfigurationOptionsThresholdDefinition"));

var _AndroidMinVersion = _interopRequireDefault(require("./model/AndroidMinVersion"));

var _ApiKey = _interopRequireDefault(require("./model/ApiKey"));

var _ApiKey2 = _interopRequireDefault(require("./model/ApiKey1"));

var _AppointmentType = _interopRequireDefault(require("./model/AppointmentType"));

var _AssetsAccessBody = _interopRequireDefault(require("./model/AssetsAccessBody"));

var _AuctionStats = _interopRequireDefault(require("./model/AuctionStats"));

var _AutoBookRequest = _interopRequireDefault(require("./model/AutoBookRequest"));

var _AutomatedVendorProfile = _interopRequireDefault(require("./model/AutomatedVendorProfile"));

var _AutomationEvent = _interopRequireDefault(require("./model/AutomationEvent"));

var _AutomationEventSubType = _interopRequireDefault(require("./model/AutomationEventSubType"));

var _AwardDeclineQuoteRequest = _interopRequireDefault(require("./model/AwardDeclineQuoteRequest"));

var _AwardQuoteRequest = _interopRequireDefault(require("./model/AwardQuoteRequest"));

var _BaseCarrierRelationship = _interopRequireDefault(require("./model/BaseCarrierRelationship"));

var _BaseCarrierRelationshipCarrierDirectIntegrationProfile = _interopRequireDefault(require("./model/BaseCarrierRelationshipCarrierDirectIntegrationProfile"));

var _BasePointOfContact = _interopRequireDefault(require("./model/BasePointOfContact"));

var _BaseProductDescription = _interopRequireDefault(require("./model/BaseProductDescription"));

var _BaseShipment = _interopRequireDefault(require("./model/BaseShipment"));

var _Bill = _interopRequireDefault(require("./model/Bill"));

var _BillDocuments = _interopRequireDefault(require("./model/BillDocuments"));

var _BillLineItem = _interopRequireDefault(require("./model/BillLineItem"));

var _BillRemitTo = _interopRequireDefault(require("./model/BillRemitTo"));

var _BillRemitToRemitToInfo = _interopRequireDefault(require("./model/BillRemitToRemitToInfo"));

var _BillShipment = _interopRequireDefault(require("./model/BillShipment"));

var _BillToOverride = _interopRequireDefault(require("./model/BillToOverride"));

var _BillingIntegrationsQuickbooksExpensesCategoriesMappingExpenseAccount = _interopRequireDefault(require("./model/BillingIntegrationsQuickbooksExpensesCategoriesMappingExpenseAccount"));

var _Brokerage = _interopRequireDefault(require("./model/Brokerage"));

var _BulkCreateSpotNegotiationRequest = _interopRequireDefault(require("./model/BulkCreateSpotNegotiationRequest"));

var _BulkPrintLabelsRequest = _interopRequireDefault(require("./model/BulkPrintLabelsRequest"));

var _BulkPrintLabelsResponse = _interopRequireDefault(require("./model/BulkPrintLabelsResponse"));

var _BulkPrintLabelsResponseLabels = _interopRequireDefault(require("./model/BulkPrintLabelsResponseLabels"));

var _BuyItNow = _interopRequireDefault(require("./model/BuyItNow"));

var _CEVARate = _interopRequireDefault(require("./model/CEVARate"));

var _CEVARates = _interopRequireDefault(require("./model/CEVARates"));

var _CEVAStateZoneRates = _interopRequireDefault(require("./model/CEVAStateZoneRates"));

var _CEVAStateZoneRates2 = _interopRequireDefault(require("./model/CEVAStateZoneRates1"));

var _CEVAZoneToZoneMapping = _interopRequireDefault(require("./model/CEVAZoneToZoneMapping"));

var _CEVAZoneToZoneMappings = _interopRequireDefault(require("./model/CEVAZoneToZoneMappings"));

var _CHRobinsonAccountRequest = _interopRequireDefault(require("./model/CHRobinsonAccountRequest"));

var _CHRobinsonAccountResponse = _interopRequireDefault(require("./model/CHRobinsonAccountResponse"));

var _CanLinkDriverResponse = _interopRequireDefault(require("./model/CanLinkDriverResponse"));

var _CancellationRequest = _interopRequireDefault(require("./model/CancellationRequest"));

var _Carrier = _interopRequireDefault(require("./model/Carrier"));

var _CarrierAssignment = _interopRequireDefault(require("./model/CarrierAssignment"));

var _CarrierBid = _interopRequireDefault(require("./model/CarrierBid"));

var _CarrierBiddingSummaryShipment = _interopRequireDefault(require("./model/CarrierBiddingSummaryShipment"));

var _CarrierCapacityAvailabilityResponse = _interopRequireDefault(require("./model/CarrierCapacityAvailabilityResponse"));

var _CarrierCapacityRecord = _interopRequireDefault(require("./model/CarrierCapacityRecord"));

var _CarrierConfig = _interopRequireDefault(require("./model/CarrierConfig"));

var _CarrierCustomData = _interopRequireDefault(require("./model/CarrierCustomData"));

var _CarrierDriver = _interopRequireDefault(require("./model/CarrierDriver"));

var _CarrierELDProvider = _interopRequireDefault(require("./model/CarrierELDProvider"));

var _CarrierInsurance = _interopRequireDefault(require("./model/CarrierInsurance"));

var _CarrierPocTag = _interopRequireDefault(require("./model/CarrierPocTag"));

var _CarrierPointOfContact = _interopRequireDefault(require("./model/CarrierPointOfContact"));

var _CarrierPointOfContactAllOf = _interopRequireDefault(require("./model/CarrierPointOfContactAllOf"));

var _CarrierReferenceCode = _interopRequireDefault(require("./model/CarrierReferenceCode"));

var _CarrierRelationship = _interopRequireDefault(require("./model/CarrierRelationship"));

var _CarrierRelationshipAllOf = _interopRequireDefault(require("./model/CarrierRelationshipAllOf"));

var _CarrierSpecificShipperRelationship = _interopRequireDefault(require("./model/CarrierSpecificShipperRelationship"));

var _CarrierStatus = _interopRequireDefault(require("./model/CarrierStatus"));

var _CarrierStatusCarrierAssignment = _interopRequireDefault(require("./model/CarrierStatusCarrierAssignment"));

var _CarrierStatusCarrierAssignmentAllOf = _interopRequireDefault(require("./model/CarrierStatusCarrierAssignmentAllOf"));

var _CarrierTag = _interopRequireDefault(require("./model/CarrierTag"));

var _CaseNote = _interopRequireDefault(require("./model/CaseNote"));

var _CellTrackingInitRequest = _interopRequireDefault(require("./model/CellTrackingInitRequest"));

var _ChangePassword = _interopRequireDefault(require("./model/ChangePassword"));

var _ChargeCategory = _interopRequireDefault(require("./model/ChargeCategory"));

var _ChargeCode = _interopRequireDefault(require("./model/ChargeCode"));

var _ChargeLineItemCategory = _interopRequireDefault(require("./model/ChargeLineItemCategory"));

var _Company = _interopRequireDefault(require("./model/Company"));

var _CompanyAllOf = _interopRequireDefault(require("./model/CompanyAllOf"));

var _CompanyCustomData = _interopRequireDefault(require("./model/CompanyCustomData"));

var _CompanyLogo = _interopRequireDefault(require("./model/CompanyLogo"));

var _CompanyPreferences = _interopRequireDefault(require("./model/CompanyPreferences"));

var _CompanyWithOptionalUsers = _interopRequireDefault(require("./model/CompanyWithOptionalUsers"));

var _CompanyWithOptionalUsersAllOf = _interopRequireDefault(require("./model/CompanyWithOptionalUsersAllOf"));

var _CompletePushResponse = _interopRequireDefault(require("./model/CompletePushResponse"));

var _ConfiguredFMS = _interopRequireDefault(require("./model/ConfiguredFMS"));

var _ConfiguredFMSConfiguredIntegrations = _interopRequireDefault(require("./model/ConfiguredFMSConfiguredIntegrations"));

var _Contract = _interopRequireDefault(require("./model/Contract"));

var _ContractRateTypes = _interopRequireDefault(require("./model/ContractRateTypes"));

var _ContractStatuses = _interopRequireDefault(require("./model/ContractStatuses"));

var _CreateApiKey = _interopRequireDefault(require("./model/CreateApiKey"));

var _CreateCompanyRequestBody = _interopRequireDefault(require("./model/CreateCompanyRequestBody"));

var _CreateEquipmentConfig = _interopRequireDefault(require("./model/CreateEquipmentConfig"));

var _CreateQuote = _interopRequireDefault(require("./model/CreateQuote"));

var _CreateQuoteAllOf = _interopRequireDefault(require("./model/CreateQuoteAllOf"));

var _CreateShipmentRepRequest = _interopRequireDefault(require("./model/CreateShipmentRepRequest"));

var _CreateShipmentTimelineEvent = _interopRequireDefault(require("./model/CreateShipmentTimelineEvent"));

var _CreateShipmentTimelineEventAllOf = _interopRequireDefault(require("./model/CreateShipmentTimelineEventAllOf"));

var _CreateShipperRelationship = _interopRequireDefault(require("./model/CreateShipperRelationship"));

var _CreateShipperRelationshipAllOf = _interopRequireDefault(require("./model/CreateShipperRelationshipAllOf"));

var _CreateSpotNegotiationQuote = _interopRequireDefault(require("./model/CreateSpotNegotiationQuote"));

var _CreateSpotNegotiationQuoteAllOf = _interopRequireDefault(require("./model/CreateSpotNegotiationQuoteAllOf"));

var _CreateTimelineEventTemplate = _interopRequireDefault(require("./model/CreateTimelineEventTemplate"));

var _CurrencyCode = _interopRequireDefault(require("./model/CurrencyCode"));

var _CurrentBillToInformation = _interopRequireDefault(require("./model/CurrentBillToInformation"));

var _CurrentShipmentAddress = _interopRequireDefault(require("./model/CurrentShipmentAddress"));

var _CurrentShipmentAddressAllOf = _interopRequireDefault(require("./model/CurrentShipmentAddressAllOf"));

var _CustomField = _interopRequireDefault(require("./model/CustomField"));

var _CustomFieldAllowedValue = _interopRequireDefault(require("./model/CustomFieldAllowedValue"));

var _CustomerCustomData = _interopRequireDefault(require("./model/CustomerCustomData"));

var _CustomerNegotiationPreview = _interopRequireDefault(require("./model/CustomerNegotiationPreview"));

var _Dashboard = _interopRequireDefault(require("./model/Dashboard"));

var _DataDocksAppointment = _interopRequireDefault(require("./model/DataDocksAppointment"));

var _DataDocksBookingInformation = _interopRequireDefault(require("./model/DataDocksBookingInformation"));

var _DataDocksStopAppointment = _interopRequireDefault(require("./model/DataDocksStopAppointment"));

var _DataImport = _interopRequireDefault(require("./model/DataImport"));

var _DataImportError = _interopRequireDefault(require("./model/DataImportError"));

var _Device = _interopRequireDefault(require("./model/Device"));

var _DistanceRequest = _interopRequireDefault(require("./model/DistanceRequest"));

var _DistanceResponse = _interopRequireDefault(require("./model/DistanceResponse"));

var _DocumentAuditlog = _interopRequireDefault(require("./model/DocumentAuditlog"));

var _DocumentMetadata = _interopRequireDefault(require("./model/DocumentMetadata"));

var _DocumentType = _interopRequireDefault(require("./model/DocumentType"));

var _Driver = _interopRequireDefault(require("./model/Driver"));

var _DriverHOS = _interopRequireDefault(require("./model/DriverHOS"));

var _DriverLog = _interopRequireDefault(require("./model/DriverLog"));

var _DriverLogin = _interopRequireDefault(require("./model/DriverLogin"));

var _DriverPinRequest = _interopRequireDefault(require("./model/DriverPinRequest"));

var _DriverPushNotificationTypesEnum = _interopRequireDefault(require("./model/DriverPushNotificationTypesEnum"));

var _DriverTokenResponse = _interopRequireDefault(require("./model/DriverTokenResponse"));

var _DriverTokenResponse2 = _interopRequireDefault(require("./model/DriverTokenResponse1"));

var _EIAFuelRate = _interopRequireDefault(require("./model/EIAFuelRate"));

var _ELDAddress = _interopRequireDefault(require("./model/ELDAddress"));

var _ELDCredentials = _interopRequireDefault(require("./model/ELDCredentials"));

var _ELDDeviceLocation = _interopRequireDefault(require("./model/ELDDeviceLocation"));

var _ELDDriverStatus = _interopRequireDefault(require("./model/ELDDriverStatus"));

var _ELDDriversCreated = _interopRequireDefault(require("./model/ELDDriversCreated"));

var _ELDDriversCreatedSkippedDrivers = _interopRequireDefault(require("./model/ELDDriversCreatedSkippedDrivers"));

var _ELDLocation = _interopRequireDefault(require("./model/ELDLocation"));

var _ELDLocationUpdateRequest = _interopRequireDefault(require("./model/ELDLocationUpdateRequest"));

var _ELDProvider = _interopRequireDefault(require("./model/ELDProvider"));

var _ETAWindow = _interopRequireDefault(require("./model/ETAWindow"));

var _EmailNotificationRequest = _interopRequireDefault(require("./model/EmailNotificationRequest"));

var _EmbedUrlResponse = _interopRequireDefault(require("./model/EmbedUrlResponse"));

var _EquipmentConfig = _interopRequireDefault(require("./model/EquipmentConfig"));

var _EquipmentEnum = _interopRequireDefault(require("./model/EquipmentEnum"));

var _EquipmentType = _interopRequireDefault(require("./model/EquipmentType"));

var _EquipmentTypes = _interopRequireDefault(require("./model/EquipmentTypes"));

var _ExtendedELDProvider = _interopRequireDefault(require("./model/ExtendedELDProvider"));

var _FMCSACarrierPolicy = _interopRequireDefault(require("./model/FMCSACarrierPolicy"));

var _FeatureFlags = _interopRequireDefault(require("./model/FeatureFlags"));

var _FedexAccount = _interopRequireDefault(require("./model/FedexAccount"));

var _FedexAccountContact = _interopRequireDefault(require("./model/FedexAccountContact"));

var _FedexAccountResponse = _interopRequireDefault(require("./model/FedexAccountResponse"));

var _FedexAccountResponseIsConnected = _interopRequireDefault(require("./model/FedexAccountResponseIsConnected"));

var _FedexDirectQuote = _interopRequireDefault(require("./model/FedexDirectQuote"));

var _FedexFreightAccount = _interopRequireDefault(require("./model/FedexFreightAccount"));

var _FedexFreightAccountAllOf = _interopRequireDefault(require("./model/FedexFreightAccountAllOf"));

var _FedexPackaging = _interopRequireDefault(require("./model/FedexPackaging"));

var _FedexShipmentOptions = _interopRequireDefault(require("./model/FedexShipmentOptions"));

var _FedexShipmentOptionsAllOf = _interopRequireDefault(require("./model/FedexShipmentOptionsAllOf"));

var _FleetLocationResponse = _interopRequireDefault(require("./model/FleetLocationResponse"));

var _FleetupCredentials = _interopRequireDefault(require("./model/FleetupCredentials"));

var _FmcsaCarrier = _interopRequireDefault(require("./model/FmcsaCarrier"));

var _FmcsaCensusData = _interopRequireDefault(require("./model/FmcsaCensusData"));

var _FormattedAddress = _interopRequireDefault(require("./model/FormattedAddress"));

var _FreightAuthorityVendorRelationshipIDList = _interopRequireDefault(require("./model/FreightAuthorityVendorRelationshipIDList"));

var _FtlInstantRateDispatchRequest = _interopRequireDefault(require("./model/FtlInstantRateDispatchRequest"));

var _FtlInstantRateDispatchResponse = _interopRequireDefault(require("./model/FtlInstantRateDispatchResponse"));

var _FuelSurchargeTable = _interopRequireDefault(require("./model/FuelSurchargeTable"));

var _FuelSurchargeTableCalculationRow = _interopRequireDefault(require("./model/FuelSurchargeTableCalculationRow"));

var _FullNameDriver = _interopRequireDefault(require("./model/FullNameDriver"));

var _FullNameDriverAllOf = _interopRequireDefault(require("./model/FullNameDriverAllOf"));

var _GenesisAddress = _interopRequireDefault(require("./model/GenesisAddress"));

var _GenesisQuote = _interopRequireDefault(require("./model/GenesisQuote"));

var _GenesisShipmentOptions = _interopRequireDefault(require("./model/GenesisShipmentOptions"));

var _GroupedEnum = _interopRequireDefault(require("./model/GroupedEnum"));

var _GroupedEnumGroup = _interopRequireDefault(require("./model/GroupedEnumGroup"));

var _GroupedEnumValue = _interopRequireDefault(require("./model/GroupedEnumValue"));

var _GroupedShipmentTimelineEvents = _interopRequireDefault(require("./model/GroupedShipmentTimelineEvents"));

var _Hazmat = _interopRequireDefault(require("./model/Hazmat"));

var _HistoricalPriceSources = _interopRequireDefault(require("./model/HistoricalPriceSources"));

var _HoursOfService = _interopRequireDefault(require("./model/HoursOfService"));

var _HoursOfServiceRecords = _interopRequireDefault(require("./model/HoursOfServiceRecords"));

var _HoursOfServiceResponse = _interopRequireDefault(require("./model/HoursOfServiceResponse"));

var _IOSMinVersion = _interopRequireDefault(require("./model/IOSMinVersion"));

var _IdentifyingCode = _interopRequireDefault(require("./model/IdentifyingCode"));

var _IdentifyingCodeType = _interopRequireDefault(require("./model/IdentifyingCodeType"));

var _ImpersonableTenant = _interopRequireDefault(require("./model/ImpersonableTenant"));

var _ImpersonableTenants = _interopRequireDefault(require("./model/ImpersonableTenants"));

var _ImpersonateUserResponse = _interopRequireDefault(require("./model/ImpersonateUserResponse"));

var _ImpersonationTokenResponse = _interopRequireDefault(require("./model/ImpersonationTokenResponse"));

var _ImportColumnMapping = _interopRequireDefault(require("./model/ImportColumnMapping"));

var _ImportJob = _interopRequireDefault(require("./model/ImportJob"));

var _ImportRow = _interopRequireDefault(require("./model/ImportRow"));

var _ImportValue = _interopRequireDefault(require("./model/ImportValue"));

var _InaccurateCarrier = _interopRequireDefault(require("./model/InaccurateCarrier"));

var _InboxMessage = _interopRequireDefault(require("./model/InboxMessage"));

var _InitiateCheckCallRequest = _interopRequireDefault(require("./model/InitiateCheckCallRequest"));

var _InitiateOrderConsolidationRequest = _interopRequireDefault(require("./model/InitiateOrderConsolidationRequest"));

var _InitiateRoutingGuideRequest = _interopRequireDefault(require("./model/InitiateRoutingGuideRequest"));

var _InlineObject = _interopRequireDefault(require("./model/InlineObject"));

var _InlineObject2 = _interopRequireDefault(require("./model/InlineObject1"));

var _InlineObject3 = _interopRequireDefault(require("./model/InlineObject10"));

var _InlineObject4 = _interopRequireDefault(require("./model/InlineObject11"));

var _InlineObject5 = _interopRequireDefault(require("./model/InlineObject12"));

var _InlineObject6 = _interopRequireDefault(require("./model/InlineObject13"));

var _InlineObject7 = _interopRequireDefault(require("./model/InlineObject14"));

var _InlineObject8 = _interopRequireDefault(require("./model/InlineObject15"));

var _InlineObject9 = _interopRequireDefault(require("./model/InlineObject2"));

var _InlineObject10 = _interopRequireDefault(require("./model/InlineObject3"));

var _InlineObject11 = _interopRequireDefault(require("./model/InlineObject4"));

var _InlineObject12 = _interopRequireDefault(require("./model/InlineObject5"));

var _InlineObject13 = _interopRequireDefault(require("./model/InlineObject6"));

var _InlineObject14 = _interopRequireDefault(require("./model/InlineObject7"));

var _InlineObject15 = _interopRequireDefault(require("./model/InlineObject8"));

var _InlineObject16 = _interopRequireDefault(require("./model/InlineObject9"));

var _InlineResponse = _interopRequireDefault(require("./model/InlineResponse200"));

var _InlineResponse2 = _interopRequireDefault(require("./model/InlineResponse2001"));

var _InlineResponse3 = _interopRequireDefault(require("./model/InlineResponse2002"));

var _InlineResponse200ManagedContent = _interopRequireDefault(require("./model/InlineResponse200ManagedContent"));

var _InlineResponse200ManagedContentDashboards = _interopRequireDefault(require("./model/InlineResponse200ManagedContentDashboards"));

var _Invoice = _interopRequireDefault(require("./model/Invoice"));

var _InvoiceCustomData = _interopRequireDefault(require("./model/InvoiceCustomData"));

var _InvoiceEmailResponse = _interopRequireDefault(require("./model/InvoiceEmailResponse"));

var _InvoiceEmailResponseInvoice = _interopRequireDefault(require("./model/InvoiceEmailResponseInvoice"));

var _InvoiceLineItemCustomData = _interopRequireDefault(require("./model/InvoiceLineItemCustomData"));

var _InvoiceLineItems = _interopRequireDefault(require("./model/InvoiceLineItems"));

var _InvoiceUpdateRequest = _interopRequireDefault(require("./model/InvoiceUpdateRequest"));

var _InvoicingShipmentsShipmentIdInvoicesLineItems = _interopRequireDefault(require("./model/InvoicingShipmentsShipmentIdInvoicesLineItems"));

var _JobRole = _interopRequireDefault(require("./model/JobRole"));

var _KeepTruckinCredentials = _interopRequireDefault(require("./model/KeepTruckinCredentials"));

var _LegLocationResponse = _interopRequireDefault(require("./model/LegLocationResponse"));

var _LegTag = _interopRequireDefault(require("./model/LegTag"));

var _LegTag2 = _interopRequireDefault(require("./model/LegTag1"));

var _LetterOfReleaseDocument = _interopRequireDefault(require("./model/LetterOfReleaseDocument"));

var _LinearFeetEstimate = _interopRequireDefault(require("./model/LinearFeetEstimate"));

var _LinkDriver = _interopRequireDefault(require("./model/LinkDriver"));

var _LinkQuoteToSpotNegotiationRequest = _interopRequireDefault(require("./model/LinkQuoteToSpotNegotiationRequest"));

var _ListTriumphPayDocumentsSubmissionEmail = _interopRequireDefault(require("./model/ListTriumphPayDocumentsSubmissionEmail"));

var _LoadBoardBiddingStatuses = _interopRequireDefault(require("./model/LoadBoardBiddingStatuses"));

var _LoadBoardShipment = _interopRequireDefault(require("./model/LoadBoardShipment"));

var _LoadBoardTenderStatuses = _interopRequireDefault(require("./model/LoadBoardTenderStatuses"));

var _LoadCapacitySchedule = _interopRequireDefault(require("./model/LoadCapacitySchedule"));

var _LocationCapacityAvailabilityResponse = _interopRequireDefault(require("./model/LocationCapacityAvailabilityResponse"));

var _LocationCustomData = _interopRequireDefault(require("./model/LocationCustomData"));

var _LocationRating = _interopRequireDefault(require("./model/LocationRating"));

var _LocationTemplate = _interopRequireDefault(require("./model/LocationTemplate"));

var _LocationType = _interopRequireDefault(require("./model/LocationType"));

var _Login = _interopRequireDefault(require("./model/Login"));

var _LoginResponse = _interopRequireDefault(require("./model/LoginResponse"));

var _MagicLinkRequest = _interopRequireDefault(require("./model/MagicLinkRequest"));

var _Markup = _interopRequireDefault(require("./model/Markup"));

var _MeResponse = _interopRequireDefault(require("./model/MeResponse"));

var _MessageListShipmentMessage = _interopRequireDefault(require("./model/MessageListShipmentMessage"));

var _MileageException = _interopRequireDefault(require("./model/MileageException"));

var _MileageType = _interopRequireDefault(require("./model/MileageType"));

var _NMFC = _interopRequireDefault(require("./model/NMFC"));

var _NetsuiteCategory = _interopRequireDefault(require("./model/NetsuiteCategory"));

var _NetsuiteCategoryOptions = _interopRequireDefault(require("./model/NetsuiteCategoryOptions"));

var _NetsuiteCompanyOptions = _interopRequireDefault(require("./model/NetsuiteCompanyOptions"));

var _NetsuiteConfig = _interopRequireDefault(require("./model/NetsuiteConfig"));

var _NetsuiteConfigCategoryMapping = _interopRequireDefault(require("./model/NetsuiteConfigCategoryMapping"));

var _NetsuiteConfigCategoryMappings = _interopRequireDefault(require("./model/NetsuiteConfigCategoryMappings"));

var _NetsuiteConfigFieldMappings = _interopRequireDefault(require("./model/NetsuiteConfigFieldMappings"));

var _NetsuiteCustomField = _interopRequireDefault(require("./model/NetsuiteCustomField"));

var _NetsuiteCustomFieldOptions = _interopRequireDefault(require("./model/NetsuiteCustomFieldOptions"));

var _NetsuiteFieldOption = _interopRequireDefault(require("./model/NetsuiteFieldOption"));

var _NoContentResponse = _interopRequireDefault(require("./model/NoContentResponse"));

var _NotificationPreference = _interopRequireDefault(require("./model/NotificationPreference"));

var _NotifyShipmentsNotTracking = _interopRequireDefault(require("./model/NotifyShipmentsNotTracking"));

var _OpenCloseSpotNegotiationsRequest = _interopRequireDefault(require("./model/OpenCloseSpotNegotiationsRequest"));

var _OperatingAuthority = _interopRequireDefault(require("./model/OperatingAuthority"));

var _OrderConsolidationPolicyCustomer = _interopRequireDefault(require("./model/OrderConsolidationPolicyCustomer"));

var _OrderConsolidationPolicyProduct = _interopRequireDefault(require("./model/OrderConsolidationPolicyProduct"));

var _OrderConsolidationPolicySupplier = _interopRequireDefault(require("./model/OrderConsolidationPolicySupplier"));

var _OverallStatusesResponse = _interopRequireDefault(require("./model/OverallStatusesResponse"));

var _PackageType = _interopRequireDefault(require("./model/PackageType"));

var _PaginatedAPIKeys = _interopRequireDefault(require("./model/PaginatedAPIKeys"));

var _PaginatedAccessorialChargeTable = _interopRequireDefault(require("./model/PaginatedAccessorialChargeTable"));

var _PaginatedAddressBookEntry = _interopRequireDefault(require("./model/PaginatedAddressBookEntry"));

var _PaginatedAlertEvent = _interopRequireDefault(require("./model/PaginatedAlertEvent"));

var _PaginatedAlertsDashBoardConfiguration = _interopRequireDefault(require("./model/PaginatedAlertsDashBoardConfiguration"));

var _PaginatedAutomationEvent = _interopRequireDefault(require("./model/PaginatedAutomationEvent"));

var _PaginatedBill = _interopRequireDefault(require("./model/PaginatedBill"));

var _PaginatedCarrierBid = _interopRequireDefault(require("./model/PaginatedCarrierBid"));

var _PaginatedCarrierBiddingSummaryShipment = _interopRequireDefault(require("./model/PaginatedCarrierBiddingSummaryShipment"));

var _PaginatedCarrierCarrierCapacityRecord = _interopRequireDefault(require("./model/PaginatedCarrierCarrierCapacityRecord"));

var _PaginatedCarrierPocTag = _interopRequireDefault(require("./model/PaginatedCarrierPocTag"));

var _PaginatedCarrierTag = _interopRequireDefault(require("./model/PaginatedCarrierTag"));

var _PaginatedCaseNote = _interopRequireDefault(require("./model/PaginatedCaseNote"));

var _PaginatedCompany = _interopRequireDefault(require("./model/PaginatedCompany"));

var _PaginatedContract = _interopRequireDefault(require("./model/PaginatedContract"));

var _PaginatedCustomField = _interopRequireDefault(require("./model/PaginatedCustomField"));

var _PaginatedDataImport = _interopRequireDefault(require("./model/PaginatedDataImport"));

var _PaginatedDataImportError = _interopRequireDefault(require("./model/PaginatedDataImportError"));

var _PaginatedDocumentMetadata = _interopRequireDefault(require("./model/PaginatedDocumentMetadata"));

var _PaginatedDriver = _interopRequireDefault(require("./model/PaginatedDriver"));

var _PaginatedDriverLog = _interopRequireDefault(require("./model/PaginatedDriverLog"));

var _PaginatedDriverMessages = _interopRequireDefault(require("./model/PaginatedDriverMessages"));

var _PaginatedEIAFuelRate = _interopRequireDefault(require("./model/PaginatedEIAFuelRate"));

var _PaginatedFmcsaCarrier = _interopRequireDefault(require("./model/PaginatedFmcsaCarrier"));

var _PaginatedFuelSurchargeTable = _interopRequireDefault(require("./model/PaginatedFuelSurchargeTable"));

var _PaginatedImportColumnMapping = _interopRequireDefault(require("./model/PaginatedImportColumnMapping"));

var _PaginatedImportJob = _interopRequireDefault(require("./model/PaginatedImportJob"));

var _PaginatedImportRow = _interopRequireDefault(require("./model/PaginatedImportRow"));

var _PaginatedInboxMessage = _interopRequireDefault(require("./model/PaginatedInboxMessage"));

var _PaginatedInvoice = _interopRequireDefault(require("./model/PaginatedInvoice"));

var _PaginatedInvoice2 = _interopRequireDefault(require("./model/PaginatedInvoice1"));

var _PaginatedLoadBoardShipment = _interopRequireDefault(require("./model/PaginatedLoadBoardShipment"));

var _PaginatedPointOfContact = _interopRequireDefault(require("./model/PaginatedPointOfContact"));

var _PaginatedPolicy = _interopRequireDefault(require("./model/PaginatedPolicy"));

var _PaginatedPowerUnit = _interopRequireDefault(require("./model/PaginatedPowerUnit"));

var _PaginatedProduct = _interopRequireDefault(require("./model/PaginatedProduct"));

var _PaginatedPurchaseOrder = _interopRequireDefault(require("./model/PaginatedPurchaseOrder"));

var _PaginatedPurchaseOrderLineItem = _interopRequireDefault(require("./model/PaginatedPurchaseOrderLineItem"));

var _PaginatedPushNotification = _interopRequireDefault(require("./model/PaginatedPushNotification"));

var _PaginatedQuickbooksBill = _interopRequireDefault(require("./model/PaginatedQuickbooksBill"));

var _PaginatedQuickbooksExpenseClass = _interopRequireDefault(require("./model/PaginatedQuickbooksExpenseClass"));

var _PaginatedQuickbooksExpensesCategoryMapping = _interopRequireDefault(require("./model/PaginatedQuickbooksExpensesCategoryMapping"));

var _PaginatedQuickbooksGLAccount = _interopRequireDefault(require("./model/PaginatedQuickbooksGLAccount"));

var _PaginatedQuickbooksItemCategoryMapping = _interopRequireDefault(require("./model/PaginatedQuickbooksItemCategoryMapping"));

var _PaginatedQuickbooksItems = _interopRequireDefault(require("./model/PaginatedQuickbooksItems"));

var _PaginatedQuote = _interopRequireDefault(require("./model/PaginatedQuote"));

var _PaginatedRecordedELDProvider = _interopRequireDefault(require("./model/PaginatedRecordedELDProvider"));

var _PaginatedRecordedEquipmentType = _interopRequireDefault(require("./model/PaginatedRecordedEquipmentType"));

var _PaginatedRfpBid = _interopRequireDefault(require("./model/PaginatedRfpBid"));

var _PaginatedRfpRow = _interopRequireDefault(require("./model/PaginatedRfpRow"));

var _PaginatedServiceLevelAgreement = _interopRequireDefault(require("./model/PaginatedServiceLevelAgreement"));

var _PaginatedShipment = _interopRequireDefault(require("./model/PaginatedShipment"));

var _PaginatedShipmentCase = _interopRequireDefault(require("./model/PaginatedShipmentCase"));

var _PaginatedShipmentDocumentMetadata = _interopRequireDefault(require("./model/PaginatedShipmentDocumentMetadata"));

var _PaginatedShipmentMessage = _interopRequireDefault(require("./model/PaginatedShipmentMessage"));

var _PaginatedShipmentNote = _interopRequireDefault(require("./model/PaginatedShipmentNote"));

var _PaginatedShipmentPickup = _interopRequireDefault(require("./model/PaginatedShipmentPickup"));

var _PaginatedShipmentRep = _interopRequireDefault(require("./model/PaginatedShipmentRep"));

var _PaginatedShipmentSpotNegotiation = _interopRequireDefault(require("./model/PaginatedShipmentSpotNegotiation"));

var _PaginatedShipmentStopLocation = _interopRequireDefault(require("./model/PaginatedShipmentStopLocation"));

var _PaginatedShipmentTag = _interopRequireDefault(require("./model/PaginatedShipmentTag"));

var _PaginatedShipmentTimelineEvent = _interopRequireDefault(require("./model/PaginatedShipmentTimelineEvent"));

var _PaginatedShipperRelationship = _interopRequireDefault(require("./model/PaginatedShipperRelationship"));

var _PaginatedSlimCarrierRelationship = _interopRequireDefault(require("./model/PaginatedSlimCarrierRelationship"));

var _PaginatedSlimShipment = _interopRequireDefault(require("./model/PaginatedSlimShipment"));

var _PaginatedSlimShipment2 = _interopRequireDefault(require("./model/PaginatedSlimShipment1"));

var _PaginatedSpotNegotiation = _interopRequireDefault(require("./model/PaginatedSpotNegotiation"));

var _PaginatedSpotNegotiationMessage = _interopRequireDefault(require("./model/PaginatedSpotNegotiationMessage"));

var _PaginatedSpotNegotiationQuote = _interopRequireDefault(require("./model/PaginatedSpotNegotiationQuote"));

var _PaginatedStop = _interopRequireDefault(require("./model/PaginatedStop"));

var _PaginatedStopAlert = _interopRequireDefault(require("./model/PaginatedStopAlert"));

var _PaginatedSupplierInvite = _interopRequireDefault(require("./model/PaginatedSupplierInvite"));

var _PaginatedTask = _interopRequireDefault(require("./model/PaginatedTask"));

var _PaginatedTenders = _interopRequireDefault(require("./model/PaginatedTenders"));

var _PaginatedTenders2 = _interopRequireDefault(require("./model/PaginatedTenders1"));

var _PaginatedTimelineEventTemplate = _interopRequireDefault(require("./model/PaginatedTimelineEventTemplate"));

var _PaginatedTrackingNotificationConfig = _interopRequireDefault(require("./model/PaginatedTrackingNotificationConfig"));

var _PaginatedTrailer = _interopRequireDefault(require("./model/PaginatedTrailer"));

var _PaginatedTriumphPayVendorFactoringCompanyEntry = _interopRequireDefault(require("./model/PaginatedTriumphPayVendorFactoringCompanyEntry"));

var _PaginatedTriumphPayVendors = _interopRequireDefault(require("./model/PaginatedTriumphPayVendors"));

var _PaginatedUser = _interopRequireDefault(require("./model/PaginatedUser"));

var _PaginatedUserDashboardConfiguration = _interopRequireDefault(require("./model/PaginatedUserDashboardConfiguration"));

var _PaginatedVendorRelationship = _interopRequireDefault(require("./model/PaginatedVendorRelationship"));

var _PaginatedWatchedShipment = _interopRequireDefault(require("./model/PaginatedWatchedShipment"));

var _PaginatedWatchedShipmentResults = _interopRequireDefault(require("./model/PaginatedWatchedShipmentResults"));

var _ParcelPickupStatus = _interopRequireDefault(require("./model/ParcelPickupStatus"));

var _PaymentDefaultSuccessMessage = _interopRequireDefault(require("./model/PaymentDefaultSuccessMessage"));

var _Permission = _interopRequireDefault(require("./model/Permission"));

var _PermissionResponse = _interopRequireDefault(require("./model/PermissionResponse"));

var _PhoneNumberLookup = _interopRequireDefault(require("./model/PhoneNumberLookup"));

var _PickupPushResponse = _interopRequireDefault(require("./model/PickupPushResponse"));

var _PieceType = _interopRequireDefault(require("./model/PieceType"));

var _PointOfContact = _interopRequireDefault(require("./model/PointOfContact"));

var _PointOfContactAllOf = _interopRequireDefault(require("./model/PointOfContactAllOf"));

var _PointOfContactNotificationPreferences = _interopRequireDefault(require("./model/PointOfContactNotificationPreferences"));

var _Policy = _interopRequireDefault(require("./model/Policy"));

var _PolicyAsWorkflowTriggerConditional = _interopRequireDefault(require("./model/PolicyAsWorkflowTriggerConditional"));

var _PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments = _interopRequireDefault(require("./model/PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments"));

var _PostCompaniesCompanyidUsers = _interopRequireDefault(require("./model/PostCompaniesCompanyidUsers"));

var _PostProducts = _interopRequireDefault(require("./model/PostProducts"));

var _PostTriumphPayVendor = _interopRequireDefault(require("./model/PostTriumphPayVendor"));

var _PowerUnit = _interopRequireDefault(require("./model/PowerUnit"));

var _Product = _interopRequireDefault(require("./model/Product"));

var _ProductAllOf = _interopRequireDefault(require("./model/ProductAllOf"));

var _PurchaseOrder = _interopRequireDefault(require("./model/PurchaseOrder"));

var _PurchaseOrderAlert = _interopRequireDefault(require("./model/PurchaseOrderAlert"));

var _PurchaseOrderBuildShipmentAssemblyRequest = _interopRequireDefault(require("./model/PurchaseOrderBuildShipmentAssemblyRequest"));

var _PurchaseOrderBuildShipmentRequest = _interopRequireDefault(require("./model/PurchaseOrderBuildShipmentRequest"));

var _PurchaseOrderCustomData = _interopRequireDefault(require("./model/PurchaseOrderCustomData"));

var _PurchaseOrderLineItem = _interopRequireDefault(require("./model/PurchaseOrderLineItem"));

var _PurchaseOrderLineItemAllOf = _interopRequireDefault(require("./model/PurchaseOrderLineItemAllOf"));

var _PurchaseOrderLineItemCustomData = _interopRequireDefault(require("./model/PurchaseOrderLineItemCustomData"));

var _PurchaseOrderListResponse = _interopRequireDefault(require("./model/PurchaseOrderListResponse"));

var _PurchaseOrderListResponseAllOf = _interopRequireDefault(require("./model/PurchaseOrderListResponseAllOf"));

var _PurchaseOrderListScopedShipment = _interopRequireDefault(require("./model/PurchaseOrderListScopedShipment"));

var _PurchaseOrderResponse = _interopRequireDefault(require("./model/PurchaseOrderResponse"));

var _PurchaseOrderResponseAllOf = _interopRequireDefault(require("./model/PurchaseOrderResponseAllOf"));

var _PurchaseOrderUpdateShipmentRequest = _interopRequireDefault(require("./model/PurchaseOrderUpdateShipmentRequest"));

var _PushNotification = _interopRequireDefault(require("./model/PushNotification"));

var _QuickbooksAuthDetails = _interopRequireDefault(require("./model/QuickbooksAuthDetails"));

var _QuickbooksExpenseClass = _interopRequireDefault(require("./model/QuickbooksExpenseClass"));

var _QuickbooksExpensesCategoryMapping = _interopRequireDefault(require("./model/QuickbooksExpensesCategoryMapping"));

var _QuickbooksExpensesCategoryMappingExpenseAccount = _interopRequireDefault(require("./model/QuickbooksExpensesCategoryMappingExpenseAccount"));

var _QuickbooksGLAccount = _interopRequireDefault(require("./model/QuickbooksGLAccount"));

var _QuickbooksItem = _interopRequireDefault(require("./model/QuickbooksItem"));

var _QuickbooksItemCategoryMapping = _interopRequireDefault(require("./model/QuickbooksItemCategoryMapping"));

var _Quote = _interopRequireDefault(require("./model/Quote"));

var _QuoteChargeLineItem = _interopRequireDefault(require("./model/QuoteChargeLineItem"));

var _QuoteChargeLineItemAllOf = _interopRequireDefault(require("./model/QuoteChargeLineItemAllOf"));

var _RFQ = _interopRequireDefault(require("./model/RFQ"));

var _RFQAllOf = _interopRequireDefault(require("./model/RFQAllOf"));

var _RMISAPIAccountRequest = _interopRequireDefault(require("./model/RMISAPIAccountRequest"));

var _RMISAPIAccountResponse = _interopRequireDefault(require("./model/RMISAPIAccountResponse"));

var _RMISAgreement = _interopRequireDefault(require("./model/RMISAgreement"));

var _RMISCarrier = _interopRequireDefault(require("./model/RMISCarrier"));

var _RMISCarrierCertificationStatus = _interopRequireDefault(require("./model/RMISCarrierCertificationStatus"));

var _RMISCarrierPolicy = _interopRequireDefault(require("./model/RMISCarrierPolicy"));

var _RMISCarrierProfile = _interopRequireDefault(require("./model/RMISCarrierProfile"));

var _RMISClientCarrierAgreement = _interopRequireDefault(require("./model/RMISClientCarrierAgreement"));

var _RMISClientCarrierAgreementRuleOverride = _interopRequireDefault(require("./model/RMISClientCarrierAgreementRuleOverride"));

var _RMISContact = _interopRequireDefault(require("./model/RMISContact"));

var _RMISCoverage = _interopRequireDefault(require("./model/RMISCoverage"));

var _RMISCoverageDetails = _interopRequireDefault(require("./model/RMISCoverageDetails"));

var _RMISCoverageLimits = _interopRequireDefault(require("./model/RMISCoverageLimits"));

var _RMISDocument = _interopRequireDefault(require("./model/RMISDocument"));

var _RMISDot = _interopRequireDefault(require("./model/RMISDot"));

var _RMISDotSmsSafety = _interopRequireDefault(require("./model/RMISDotSmsSafety"));

var _RMISDotTestingInfo = _interopRequireDefault(require("./model/RMISDotTestingInfo"));

var _RMISEquipmentType = _interopRequireDefault(require("./model/RMISEquipmentType"));

var _RMISFTPAccountRequest = _interopRequireDefault(require("./model/RMISFTPAccountRequest"));

var _RMISFTPAccountResponse = _interopRequireDefault(require("./model/RMISFTPAccountResponse"));

var _RMISJobStatus = _interopRequireDefault(require("./model/RMISJobStatus"));

var _RMISNonCertifiedReason = _interopRequireDefault(require("./model/RMISNonCertifiedReason"));

var _RMISOverride = _interopRequireDefault(require("./model/RMISOverride"));

var _RMISW = _interopRequireDefault(require("./model/RMISW9"));

var _RecordedELDProvider = _interopRequireDefault(require("./model/RecordedELDProvider"));

var _RecordedEquipmentType = _interopRequireDefault(require("./model/RecordedEquipmentType"));

var _RedirectUrl = _interopRequireDefault(require("./model/RedirectUrl"));

var _RegisterFedex = _interopRequireDefault(require("./model/RegisterFedex"));

var _RegisterFedexResponse = _interopRequireDefault(require("./model/RegisterFedexResponse"));

var _RegisterFedexResponseAllOf = _interopRequireDefault(require("./model/RegisterFedexResponseAllOf"));

var _RegisterUPS = _interopRequireDefault(require("./model/RegisterUPS"));

var _RegisterUPSResponse = _interopRequireDefault(require("./model/RegisterUPSResponse"));

var _RequestPasswordReset = _interopRequireDefault(require("./model/RequestPasswordReset"));

var _RequestVerificationEmail = _interopRequireDefault(require("./model/RequestVerificationEmail"));

var _ResetPassword = _interopRequireDefault(require("./model/ResetPassword"));

var _ResetSignupInfo = _interopRequireDefault(require("./model/ResetSignupInfo"));

var _RfpBidPostImportResults = _interopRequireDefault(require("./model/RfpBidPostImportResults"));

var _RfpBidRequest = _interopRequireDefault(require("./model/RfpBidRequest"));

var _RfpBidResponse = _interopRequireDefault(require("./model/RfpBidResponse"));

var _RfpRowResponse = _interopRequireDefault(require("./model/RfpRowResponse"));

var _SaferWatchAccountRequest = _interopRequireDefault(require("./model/SaferWatchAccountRequest"));

var _SaferWatchAccountResponse = _interopRequireDefault(require("./model/SaferWatchAccountResponse"));

var _SaferWatchAuthority = _interopRequireDefault(require("./model/SaferWatchAuthority"));

var _SaferWatchCargo = _interopRequireDefault(require("./model/SaferWatchCargo"));

var _SaferWatchCarrier = _interopRequireDefault(require("./model/SaferWatchCarrier"));

var _SaferWatchCarrierPolicy = _interopRequireDefault(require("./model/SaferWatchCarrierPolicy"));

var _SaferWatchCertData = _interopRequireDefault(require("./model/SaferWatchCertData"));

var _SaferWatchCertificate = _interopRequireDefault(require("./model/SaferWatchCertificate"));

var _SaferWatchCoverage = _interopRequireDefault(require("./model/SaferWatchCoverage"));

var _SaferWatchCrash = _interopRequireDefault(require("./model/SaferWatchCrash"));

var _SaferWatchDrivers = _interopRequireDefault(require("./model/SaferWatchDrivers"));

var _SaferWatchEquipment = _interopRequireDefault(require("./model/SaferWatchEquipment"));

var _SaferWatchFmcsaInsurance = _interopRequireDefault(require("./model/SaferWatchFmcsaInsurance"));

var _SaferWatchIdentity = _interopRequireDefault(require("./model/SaferWatchIdentity"));

var _SaferWatchInspection = _interopRequireDefault(require("./model/SaferWatchInspection"));

var _SaferWatchJobStatus = _interopRequireDefault(require("./model/SaferWatchJobStatus"));

var _SaferWatchOperation = _interopRequireDefault(require("./model/SaferWatchOperation"));

var _SaferWatchOther = _interopRequireDefault(require("./model/SaferWatchOther"));

var _SaferWatchPolicyItem = _interopRequireDefault(require("./model/SaferWatchPolicyItem"));

var _SaferWatchReview = _interopRequireDefault(require("./model/SaferWatchReview"));

var _SaferWatchRiskAssessment = _interopRequireDefault(require("./model/SaferWatchRiskAssessment"));

var _SaferWatchSafety = _interopRequireDefault(require("./model/SaferWatchSafety"));

var _ScheduleShipmentPickupRequest = _interopRequireDefault(require("./model/ScheduleShipmentPickupRequest"));

var _SendDocument = _interopRequireDefault(require("./model/SendDocument"));

var _ServiceLevel = _interopRequireDefault(require("./model/ServiceLevel"));

var _ServiceLevelAgreement = _interopRequireDefault(require("./model/ServiceLevelAgreement"));

var _ServiceLevelAgreementIntervals = _interopRequireDefault(require("./model/ServiceLevelAgreementIntervals"));

var _ServiceLevelAgreementStatuses = _interopRequireDefault(require("./model/ServiceLevelAgreementStatuses"));

var _SetPassword = _interopRequireDefault(require("./model/SetPassword"));

var _ShareShipment = _interopRequireDefault(require("./model/ShareShipment"));

var _Shipment = _interopRequireDefault(require("./model/Shipment"));

var _ShipmentAlertLevel = _interopRequireDefault(require("./model/ShipmentAlertLevel"));

var _ShipmentAllOf = _interopRequireDefault(require("./model/ShipmentAllOf"));

var _ShipmentCase = _interopRequireDefault(require("./model/ShipmentCase"));

var _ShipmentChargeLineItem = _interopRequireDefault(require("./model/ShipmentChargeLineItem"));

var _ShipmentChargeLineItemAllOf = _interopRequireDefault(require("./model/ShipmentChargeLineItemAllOf"));

var _ShipmentChargeLineItemTemplate = _interopRequireDefault(require("./model/ShipmentChargeLineItemTemplate"));

var _ShipmentCustomData = _interopRequireDefault(require("./model/ShipmentCustomData"));

var _ShipmentDocumentMetadata = _interopRequireDefault(require("./model/ShipmentDocumentMetadata"));

var _ShipmentDocumentMetadataAllOf = _interopRequireDefault(require("./model/ShipmentDocumentMetadataAllOf"));

var _ShipmentLineItem = _interopRequireDefault(require("./model/ShipmentLineItem"));

var _ShipmentLineItemAllOf = _interopRequireDefault(require("./model/ShipmentLineItemAllOf"));

var _ShipmentLineItemCustomData = _interopRequireDefault(require("./model/ShipmentLineItemCustomData"));

var _ShipmentLocationResponse = _interopRequireDefault(require("./model/ShipmentLocationResponse"));

var _ShipmentMessage = _interopRequireDefault(require("./model/ShipmentMessage"));

var _ShipmentMetadata = _interopRequireDefault(require("./model/ShipmentMetadata"));

var _ShipmentMetadataCustomData = _interopRequireDefault(require("./model/ShipmentMetadataCustomData"));

var _ShipmentMode = _interopRequireDefault(require("./model/ShipmentMode"));

var _ShipmentModeStatus = _interopRequireDefault(require("./model/ShipmentModeStatus"));

var _ShipmentNote = _interopRequireDefault(require("./model/ShipmentNote"));

var _ShipmentPickup = _interopRequireDefault(require("./model/ShipmentPickup"));

var _ShipmentPickupAllOf = _interopRequireDefault(require("./model/ShipmentPickupAllOf"));

var _ShipmentPosition = _interopRequireDefault(require("./model/ShipmentPosition"));

var _ShipmentRep = _interopRequireDefault(require("./model/ShipmentRep"));

var _ShipmentRepRole = _interopRequireDefault(require("./model/ShipmentRepRole"));

var _ShipmentSpotNegotiation = _interopRequireDefault(require("./model/ShipmentSpotNegotiation"));

var _ShipmentState = _interopRequireDefault(require("./model/ShipmentState"));

var _ShipmentStatusEnum = _interopRequireDefault(require("./model/ShipmentStatusEnum"));

var _ShipmentStopTemplate = _interopRequireDefault(require("./model/ShipmentStopTemplate"));

var _ShipmentTag = _interopRequireDefault(require("./model/ShipmentTag"));

var _ShipmentTemplate = _interopRequireDefault(require("./model/ShipmentTemplate"));

var _ShipmentTimelineEvent = _interopRequireDefault(require("./model/ShipmentTimelineEvent"));

var _ShipmentTimelineEventCustomData = _interopRequireDefault(require("./model/ShipmentTimelineEventCustomData"));

var _ShipmentTimelineFilterPreferences = _interopRequireDefault(require("./model/ShipmentTimelineFilterPreferences"));

var _Shipper = _interopRequireDefault(require("./model/Shipper"));

var _ShipperRelationship = _interopRequireDefault(require("./model/ShipperRelationship"));

var _ShipwellError = _interopRequireDefault(require("./model/ShipwellError"));

var _ShipwellErrorFieldErrorsCondensed = _interopRequireDefault(require("./model/ShipwellErrorFieldErrorsCondensed"));

var _ShopifyLogin = _interopRequireDefault(require("./model/ShopifyLogin"));

var _ShopifyLoginAllOf = _interopRequireDefault(require("./model/ShopifyLoginAllOf"));

var _ShopifySettings = _interopRequireDefault(require("./model/ShopifySettings"));

var _SlimCarrierAssignment = _interopRequireDefault(require("./model/SlimCarrierAssignment"));

var _SlimCarrierAssignmentAllOf = _interopRequireDefault(require("./model/SlimCarrierAssignmentAllOf"));

var _SlimCarrierRelationship = _interopRequireDefault(require("./model/SlimCarrierRelationship"));

var _SlimCarrierRelationshipAllOf = _interopRequireDefault(require("./model/SlimCarrierRelationshipAllOf"));

var _SlimCarrierStatusCarrierAssignment = _interopRequireDefault(require("./model/SlimCarrierStatusCarrierAssignment"));

var _SlimCompany = _interopRequireDefault(require("./model/SlimCompany"));

var _SlimDriver = _interopRequireDefault(require("./model/SlimDriver"));

var _SlimPurchaseOrder = _interopRequireDefault(require("./model/SlimPurchaseOrder"));

var _SlimRFQ = _interopRequireDefault(require("./model/SlimRFQ"));

var _SlimRMISCarrier = _interopRequireDefault(require("./model/SlimRMISCarrier"));

var _SlimRMISCarrierStatus = _interopRequireDefault(require("./model/SlimRMISCarrierStatus"));

var _SlimRMISCoverage = _interopRequireDefault(require("./model/SlimRMISCoverage"));

var _SlimRMISCoverageLimit = _interopRequireDefault(require("./model/SlimRMISCoverageLimit"));

var _SlimRMISDot = _interopRequireDefault(require("./model/SlimRMISDot"));

var _SlimRMISDotTestingInfo = _interopRequireDefault(require("./model/SlimRMISDotTestingInfo"));

var _SlimRMISJobStatus = _interopRequireDefault(require("./model/SlimRMISJobStatus"));

var _SlimSaferWatchAuthority = _interopRequireDefault(require("./model/SlimSaferWatchAuthority"));

var _SlimSaferWatchCarrier = _interopRequireDefault(require("./model/SlimSaferWatchCarrier"));

var _SlimSaferWatchCarrierStatus = _interopRequireDefault(require("./model/SlimSaferWatchCarrierStatus"));

var _SlimSaferWatchCertData = _interopRequireDefault(require("./model/SlimSaferWatchCertData"));

var _SlimSaferWatchCoverage = _interopRequireDefault(require("./model/SlimSaferWatchCoverage"));

var _SlimSaferWatchFMCSAInsurance = _interopRequireDefault(require("./model/SlimSaferWatchFMCSAInsurance"));

var _SlimSaferWatchOperation = _interopRequireDefault(require("./model/SlimSaferWatchOperation"));

var _SlimSaferWatchPolicyItem = _interopRequireDefault(require("./model/SlimSaferWatchPolicyItem"));

var _SlimSaferWatchReview = _interopRequireDefault(require("./model/SlimSaferWatchReview"));

var _SlimSaferWatchRiskAssessment = _interopRequireDefault(require("./model/SlimSaferWatchRiskAssessment"));

var _SlimSaferWatchSafety = _interopRequireDefault(require("./model/SlimSaferWatchSafety"));

var _SlimShipment = _interopRequireDefault(require("./model/SlimShipment"));

var _SlimShipmentAllOf = _interopRequireDefault(require("./model/SlimShipmentAllOf"));

var _SlimShipmentLineItem = _interopRequireDefault(require("./model/SlimShipmentLineItem"));

var _SlimStop = _interopRequireDefault(require("./model/SlimStop"));

var _SlimUser = _interopRequireDefault(require("./model/SlimUser"));

var _SpotNegotiation = _interopRequireDefault(require("./model/SpotNegotiation"));

var _SpotNegotiationMessage = _interopRequireDefault(require("./model/SpotNegotiationMessage"));

var _SpotNegotiationPreview = _interopRequireDefault(require("./model/SpotNegotiationPreview"));

var _SpotNegotiationQuoteInfo = _interopRequireDefault(require("./model/SpotNegotiationQuoteInfo"));

var _Stop = _interopRequireDefault(require("./model/Stop"));

var _StopAlert = _interopRequireDefault(require("./model/StopAlert"));

var _StopCustomData = _interopRequireDefault(require("./model/StopCustomData"));

var _StopEvent = _interopRequireDefault(require("./model/StopEvent"));

var _StopLocation = _interopRequireDefault(require("./model/StopLocation"));

var _StopPointOfContactTemplate = _interopRequireDefault(require("./model/StopPointOfContactTemplate"));

var _SupplierInvite = _interopRequireDefault(require("./model/SupplierInvite"));

var _SupplierInviteResponse = _interopRequireDefault(require("./model/SupplierInviteResponse"));

var _SupplierInviteResponseAllOf = _interopRequireDefault(require("./model/SupplierInviteResponseAllOf"));

var _Task = _interopRequireDefault(require("./model/Task"));

var _TeletracCredentials = _interopRequireDefault(require("./model/TeletracCredentials"));

var _TenderAcceptReject = _interopRequireDefault(require("./model/TenderAcceptReject"));

var _TenderAcceptRejectDetails = _interopRequireDefault(require("./model/TenderAcceptRejectDetails"));

var _TenderAppointmentEventRequest = _interopRequireDefault(require("./model/TenderAppointmentEventRequest"));

var _TenderBase = _interopRequireDefault(require("./model/TenderBase"));

var _TenderChargeLineItem = _interopRequireDefault(require("./model/TenderChargeLineItem"));

var _TenderCreate = _interopRequireDefault(require("./model/TenderCreate"));

var _TenderCreateAllOf = _interopRequireDefault(require("./model/TenderCreateAllOf"));

var _TenderEmailPreview = _interopRequireDefault(require("./model/TenderEmailPreview"));

var _TenderEquipmentEventRequest = _interopRequireDefault(require("./model/TenderEquipmentEventRequest"));

var _TenderEtaEventRequest = _interopRequireDefault(require("./model/TenderEtaEventRequest"));

var _TenderEventRequest = _interopRequireDefault(require("./model/TenderEventRequest"));

var _TenderEventRequestEvents = _interopRequireDefault(require("./model/TenderEventRequestEvents"));

var _TenderExternalEDISystem = _interopRequireDefault(require("./model/TenderExternalEDISystem"));

var _TenderGet = _interopRequireDefault(require("./model/TenderGet"));

var _TenderGetAllOf = _interopRequireDefault(require("./model/TenderGetAllOf"));

var _TenderLocationEventRequest = _interopRequireDefault(require("./model/TenderLocationEventRequest"));

var _TenderLocationEventRequestGeoLocation = _interopRequireDefault(require("./model/TenderLocationEventRequestGeoLocation"));

var _TenderRejectRequest = _interopRequireDefault(require("./model/TenderRejectRequest"));

var _TenderRequest = _interopRequireDefault(require("./model/TenderRequest"));

var _TenderRequestCharge = _interopRequireDefault(require("./model/TenderRequestCharge"));

var _TenderRequestCustomer = _interopRequireDefault(require("./model/TenderRequestCustomer"));

var _TenderRequestEquipment = _interopRequireDefault(require("./model/TenderRequestEquipment"));

var _TenderRequestEquipmentTemperatureControl = _interopRequireDefault(require("./model/TenderRequestEquipmentTemperatureControl"));

var _TenderRequestLength = _interopRequireDefault(require("./model/TenderRequestLength"));

var _TenderRequestShipment = _interopRequireDefault(require("./model/TenderRequestShipment"));

var _TenderRequestShipmentStop = _interopRequireDefault(require("./model/TenderRequestShipmentStop"));

var _TenderRequestShipmentStopAddress = _interopRequireDefault(require("./model/TenderRequestShipmentStopAddress"));

var _TenderRequestShipmentStopContact = _interopRequireDefault(require("./model/TenderRequestShipmentStopContact"));

var _TenderRequestShipmentStopLineItem = _interopRequireDefault(require("./model/TenderRequestShipmentStopLineItem"));

var _TenderRequestTemperature = _interopRequireDefault(require("./model/TenderRequestTemperature"));

var _TenderRequestVendor = _interopRequireDefault(require("./model/TenderRequestVendor"));

var _TenderRequestWeight = _interopRequireDefault(require("./model/TenderRequestWeight"));

var _TenderShipmentStateEventRequest = _interopRequireDefault(require("./model/TenderShipmentStateEventRequest"));

var _TenderStopLocationEventRequest = _interopRequireDefault(require("./model/TenderStopLocationEventRequest"));

var _TextMessageTemplates = _interopRequireDefault(require("./model/TextMessageTemplates"));

var _TimelineEventTemplate = _interopRequireDefault(require("./model/TimelineEventTemplate"));

var _TokenResponse = _interopRequireDefault(require("./model/TokenResponse"));

var _TotalWeightOverride = _interopRequireDefault(require("./model/TotalWeightOverride"));

var _TrackingNotificationConfig = _interopRequireDefault(require("./model/TrackingNotificationConfig"));

var _Trailer = _interopRequireDefault(require("./model/Trailer"));

var _TriumphPayApprovedDateSource = _interopRequireDefault(require("./model/TriumphPayApprovedDateSource"));

var _TriumphPayAuthDetails = _interopRequireDefault(require("./model/TriumphPayAuthDetails"));

var _TriumphPayAuthSettings = _interopRequireDefault(require("./model/TriumphPayAuthSettings"));

var _TriumphPayCarrierInvoice = _interopRequireDefault(require("./model/TriumphPayCarrierInvoice"));

var _TriumphPayCarrierPaymentAccount = _interopRequireDefault(require("./model/TriumphPayCarrierPaymentAccount"));

var _TriumphPayCarrierPaymentAccountMailCheckData = _interopRequireDefault(require("./model/TriumphPayCarrierPaymentAccountMailCheckData"));

var _TriumphPayCarrierSyncedInvoice = _interopRequireDefault(require("./model/TriumphPayCarrierSyncedInvoice"));

var _TriumphPayDocumentsSubmissionEmail = _interopRequireDefault(require("./model/TriumphPayDocumentsSubmissionEmail"));

var _TriumphPayPaymentAccountTypes = _interopRequireDefault(require("./model/TriumphPayPaymentAccountTypes"));

var _TriumphPayVendor = _interopRequireDefault(require("./model/TriumphPayVendor"));

var _TriumphPayVendorConnectionEstablishedSuccessMessage = _interopRequireDefault(require("./model/TriumphPayVendorConnectionEstablishedSuccessMessage"));

var _TriumphPayVendorFreightAuthorityVendorRelationshipDetails = _interopRequireDefault(require("./model/TriumphPayVendorFreightAuthorityVendorRelationshipDetails"));

var _TriumphPayVendorPaymentAccountData = _interopRequireDefault(require("./model/TriumphPayVendorPaymentAccountData"));

var _TriumphPayVendorPaymentAccountDataBankAccountData = _interopRequireDefault(require("./model/TriumphPayVendorPaymentAccountDataBankAccountData"));

var _TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocuments = _interopRequireDefault(require("./model/TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocuments"));

var _TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocumentsAllOf = _interopRequireDefault(require("./model/TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocumentsAllOf"));

var _UPSAccount = _interopRequireDefault(require("./model/UPSAccount"));

var _UPSDirectQuote = _interopRequireDefault(require("./model/UPSDirectQuote"));

var _UPSPackaging = _interopRequireDefault(require("./model/UPSPackaging"));

var _UPSShipmentOptions = _interopRequireDefault(require("./model/UPSShipmentOptions"));

var _UPSShipmentOptionsAllOf = _interopRequireDefault(require("./model/UPSShipmentOptionsAllOf"));

var _USPSAccount = _interopRequireDefault(require("./model/USPSAccount"));

var _USPSDirectQuote = _interopRequireDefault(require("./model/USPSDirectQuote"));

var _USPSPackaging = _interopRequireDefault(require("./model/USPSPackaging"));

var _USPSShipmentOptions = _interopRequireDefault(require("./model/USPSShipmentOptions"));

var _USPSShipmentOptionsAllOf = _interopRequireDefault(require("./model/USPSShipmentOptionsAllOf"));

var _UpdateShipmentRepRequest = _interopRequireDefault(require("./model/UpdateShipmentRepRequest"));

var _UpdatedInsuranceRequest = _interopRequireDefault(require("./model/UpdatedInsuranceRequest"));

var _User = _interopRequireDefault(require("./model/User"));

var _UserCustomData = _interopRequireDefault(require("./model/UserCustomData"));

var _UserDashboardConfiguration = _interopRequireDefault(require("./model/UserDashboardConfiguration"));

var _UserDashboardConfigurationConfig = _interopRequireDefault(require("./model/UserDashboardConfigurationConfig"));

var _UserPreferences = _interopRequireDefault(require("./model/UserPreferences"));

var _ValidatedAddress = _interopRequireDefault(require("./model/ValidatedAddress"));

var _VehicleLocation = _interopRequireDefault(require("./model/VehicleLocation"));

var _VehicleLocationAllOf = _interopRequireDefault(require("./model/VehicleLocationAllOf"));

var _Vendor = _interopRequireDefault(require("./model/Vendor"));

var _VendorFactoringCompany = _interopRequireDefault(require("./model/VendorFactoringCompany"));

var _VendorRelationship = _interopRequireDefault(require("./model/VendorRelationship"));

var _VerificationResponse = _interopRequireDefault(require("./model/VerificationResponse"));

var _VerifyEmail = _interopRequireDefault(require("./model/VerifyEmail"));

var _Versions = _interopRequireDefault(require("./model/Versions"));

var _WorkflowAutomationStructuredConditional = _interopRequireDefault(require("./model/WorkflowAutomationStructuredConditional"));

var _DefaultApi = _interopRequireDefault(require("./api/DefaultApi"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }